module.exports = {
	"EOSQ051": {
		"UNK": null,
		"NOR": {
			"v": 6.17,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.81,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.65,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.51,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.76,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.46,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.03,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.63,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.45,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.87,
			"r": "42",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.24,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.71,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.17,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.02,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.33,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.29,
			"r": "31",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.29,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.92,
			"r": "12",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.64,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.25,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.07,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.38,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.84,
			"r": "106",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.12,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.36,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.22,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.08,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.81,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.37,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.95,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.27,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.27,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.41,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.01,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.25,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.51,
			"r": "141",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.99,
			"r": "95",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.49,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.47,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.07,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.24,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.19,
			"r": "77",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.89,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.85,
			"r": "104",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.99,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.84,
			"r": "91",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.94,
			"r": "100",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.69,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.53,
			"r": "120",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.97,
			"r": "131",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.49,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.13,
			"r": "80",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.61,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.71,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.35,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.72,
			"r": "109",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.25,
			"r": "122",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.02,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.07,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.95,
			"r": "95",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.91,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 4.68,
			"r": "51",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.73,
			"r": "21",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.09,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.45,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.85,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.67,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.87,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.15,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.24,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.74,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.19,
			"r": "125",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.28,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.37,
			"r": "58",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.03,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.14,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.36,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.78,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.96,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.62,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.36,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.05,
			"r": "130",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.21,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.74,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.43,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.98,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.27,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.17,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.57,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.19,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.23,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.32,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.22,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.63,
			"r": "117",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.54,
			"r": "119",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.74,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.45,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.51,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.18,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.92,
			"r": "13",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.76,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.96,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.29,
			"r": "65",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.77,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.28,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.77,
			"r": "43",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.48,
			"r": "53",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.75,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.5,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 3.94,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.52,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.27,
			"r": "68",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.48,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.54,
			"r": "25",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.52,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.61,
			"r": "23",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.35,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.17,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.01,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.81,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.03,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.31,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.84,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.11,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.83,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.76,
			"r": "112",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.32,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.24,
			"r": "34",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.49,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.74,
			"r": "20",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.14,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.05,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.58,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.44,
			"r": "55",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.18,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.08,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.78,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.8,
			"r": "132",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.94,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.18,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.9,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.15,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.9,
			"r": "41",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIB03": {
		"UNK": null,
		"NOR": {
			"v": 5.93,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.36,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.41,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.85,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.99,
			"r": "129",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "58",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.7,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.83,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.7,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.73,
			"r": "65",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.35,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.44,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.59,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5,
			"r": "47",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.77,
			"r": "63",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.85,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.52,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.54,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.51,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.59,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.09,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.27,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.77,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.29,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.64,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.27,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "107",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.63,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.48,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.7,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.32,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.29,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.31,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.06,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.22,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.88,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.97,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.05,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5,
			"r": "49",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.92,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.08,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.4,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.13,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.11,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.22,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.85,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.8,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.81,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.52,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.81,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.99,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.38,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.94,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.62,
			"r": "32",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.71,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.82,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.89,
			"r": "53",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.15,
			"r": "89",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.21,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.15,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.96,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.52,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.07,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.87,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.86,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.76,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.78,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.19,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.1,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.63,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.81,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.9,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.74,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.39,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.11,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.18,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.83,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.99,
			"r": "50",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.88,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.71,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.4,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.29,
			"r": "5",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.01,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.2,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.53,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.26,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.29,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.53,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.2,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.45,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.75,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.72,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.18,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.93,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.15,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.91,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.89,
			"r": "17",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.06,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.06,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.8,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.96,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.06,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.4,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.28,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.34,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.53,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.75,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.14,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.19,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.72,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.64,
			"r": "69",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.35,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "90",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.89,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.71,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.95,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.69,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.82,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.76,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"int_cooperation": {
		"UNK": null,
		"NOR": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 1,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.75,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.33,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.67,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2012",
			"m": 88
		},
		"EGY": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"TJK": null,
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 2,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 2,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.67,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.67,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 2,
			"y": "2012",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 6": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ146": {
		"UNK": null,
		"NOR": {
			"v": 6.03,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.93,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.24,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 2.86,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.06,
			"r": "131",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.19,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "49",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 2.54,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.51,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.72,
			"r": "60",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.34,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.58,
			"r": "32",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.24,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.37,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.67,
			"r": "31",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.49,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.91,
			"r": "44",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.36,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.47,
			"r": "118",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.71,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.4,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.51,
			"r": "68",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.88,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.09,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.91,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.34,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.38,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.64,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.81,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.56,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.15,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.36,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.02,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.92,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.84,
			"r": "139",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.24,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.94,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.28,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.48,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.5,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4,
			"r": "47",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.65,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.27,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.45,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.63,
			"r": "108",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.53,
			"r": "67",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.31,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.1,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.19,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.09,
			"r": "133",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.98,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.82,
			"r": "135",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.17,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.34,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.6,
			"r": "16",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.49,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.15,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.89,
			"r": "88",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 1.93,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.55,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.15,
			"r": "44",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 2.88,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.73,
			"r": "103",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.46,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.93,
			"r": "100",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.48,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.63,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.98,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.71,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.69,
			"r": "53",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.28,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.05,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.81,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.2,
			"r": "128",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.81,
			"r": "14",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.64,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.32,
			"r": "39",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.16,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.92,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.86,
			"r": "13",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.58,
			"r": "112",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.01,
			"r": "135",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.54,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.76,
			"r": "136",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.57,
			"r": "113",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.01,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.75,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.61,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 2.37,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.59,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.44,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.96,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.9,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.17,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.13,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.29,
			"r": "81",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.3,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.24,
			"r": "84",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.4,
			"r": "75",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.77,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.21,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.15,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.95,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.93,
			"r": "99",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.72,
			"r": "30",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.92,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.87,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.9,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.9,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.41,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.22,
			"r": "42",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.43,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.03,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.11,
			"r": "131",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.49,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.09,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.05,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.08,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.05,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.77,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.14,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.9,
			"r": "26",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.33,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.36,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.6,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.96,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.45,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.23,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.86,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.18,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.39,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.89,
			"r": "55",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.1,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.79,
			"r": "58",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.52,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.15,
			"r": "5",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.75,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.44,
			"r": "121",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.7,
			"r": "109",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.83,
			"r": "57",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.45,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.31,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.94,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.18,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.18,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.59,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.32,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.44,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.46,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.27,
			"r": "40",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIB": {
		"UNK": null,
		"NOR": {
			"v": 5.93,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.36,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.41,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.85,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.99,
			"r": "129",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "58",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.7,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.83,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.7,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.73,
			"r": "65",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.35,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.44,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.59,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5,
			"r": "47",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.77,
			"r": "63",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.85,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.52,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.54,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.51,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.59,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.09,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.27,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.77,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.29,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.64,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.27,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "107",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.63,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.48,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.7,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.32,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.29,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.31,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.06,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.22,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.88,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.97,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.05,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5,
			"r": "49",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.92,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.08,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.4,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.13,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.11,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.22,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.85,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.8,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.81,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.52,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.81,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.99,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.38,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.94,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.62,
			"r": "32",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.71,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.82,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.89,
			"r": "53",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.15,
			"r": "89",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.21,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.15,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.96,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.52,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.07,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.87,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.86,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.76,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.78,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.19,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.1,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.63,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.81,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.9,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.74,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.39,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.11,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.18,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.83,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.99,
			"r": "50",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.88,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.71,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.4,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.29,
			"r": "5",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.01,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.2,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.53,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.26,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.29,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.53,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.2,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.45,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.75,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.72,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.18,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.93,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.15,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.91,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.89,
			"r": "17",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.06,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.06,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.8,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.96,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.06,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.4,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.28,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.34,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.53,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.75,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.14,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.19,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.72,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.64,
			"r": "69",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.35,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "90",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.89,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.71,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.95,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.69,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.82,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.76,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TABTIMEIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1090,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 180,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 84,
			"r": "101",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 208.8,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 120,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "26",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 38,
			"r": "74",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 72,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 72,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 32,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 10,
			"r": "55",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.62,
			"r": "33",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 24.33,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 16,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 44,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 132,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 96,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 84,
			"r": "101",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 17.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 13.33,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 140,
			"r": "118",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 36,
			"r": "70",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 48,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 180,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 172.71,
			"r": "124",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 1,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 48,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 138.38,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 192,
			"r": "126",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 10.45,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 270,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 63.46,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 36,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 265,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.5,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 147,
			"r": "120",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 36,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 96,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1.56,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 120,
			"r": "107",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 54.86,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 26,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 72,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 156,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 24,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 13.5,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 44,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 174,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 6,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.5,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 120,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 126,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4,
			"r": "46",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 26,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.75,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 33,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 89.14,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 8,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 192,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1.67,
			"r": "34",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.5,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.31,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 1.56,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 132.88,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 72,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 156,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 58,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 96,
			"r": "104",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 1.32,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 216,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 36,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 76,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 172,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 28,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 0.81,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 31.5,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 248.73,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 8,
			"r": "51",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 77,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 23,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 4,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 144,
			"r": "119",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.5,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 72,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 8.62,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 324,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 72,
			"r": "89",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 36,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 131.08,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2,
			"r": "35",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 134,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 64,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 96,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 61.29,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 26.92,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 76,
			"r": "97",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 42.5,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 65.7,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7.5,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 11.08,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.35,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 72,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 168,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 3,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 58.67,
			"r": "83",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 64,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 2.5,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 216,
			"r": "129",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.25,
			"r": "43",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 137.14,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 12,
			"r": "58",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 8,
			"r": "51",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 48,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 81,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 120,
			"r": "107",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 72,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 163,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 114.67,
			"r": "106",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 44,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 240,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 57.64,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 1,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 1,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 40.62,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 74,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"MOBBBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 92.83,
			"r": "19",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 75.42,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 42.97,
			"r": "75",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 68.81,
			"r": "41",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 7.56,
			"r": "129",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 131.78,
			"r": "4",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.95,
			"r": "121",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 35.09,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 74.65,
			"r": "36",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 109.67,
			"r": "12",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 60.92,
			"r": "53",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 53.51,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 77.71,
			"r": "31",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 63.17,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 10.08,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 89.94,
			"r": "21",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 41.29,
			"r": "79",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 9.37,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 7.22,
			"r": "130",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 56.19,
			"r": "60",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 56.06,
			"r": "61",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 42.8,
			"r": "76",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 41.58,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 15.5,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 37.7,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 50.36,
			"r": "72",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 19.94,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 74.22,
			"r": "37",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 63.53,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 4.48,
			"r": "132",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 57.61,
			"r": "57",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 67.04,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5.85,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 69.57,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 19.33,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 20.95,
			"r": "105",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 52.04,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 144.05,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 21.1,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 18.31,
			"r": "110",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 20.52,
			"r": "106",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 43.65,
			"r": "74",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 20.02,
			"r": "107",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 16.59,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 12.13,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 50.66,
			"r": "70",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 81.29,
			"r": "27",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 13.02,
			"r": "119",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 75.28,
			"r": "34",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 30.98,
			"r": "100",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 80.56,
			"y": "2014",
			"m": 100
		},
		"CHE": {
			"v": 97.61,
			"r": "15",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 88.62,
			"r": "22",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 35.58,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 95.52,
			"r": "16",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 25.88,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 52.03,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 0.23,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 66.55,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 39.61,
			"r": "85",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 32.22,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 43.99,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 32.66,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 66.59,
			"r": "48",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 33.12,
			"r": "97",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 12.08,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 112.86,
			"r": "10",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 39.28,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 39.8,
			"r": "84",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 19.14,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 40.39,
			"r": "82",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 82.06,
			"r": "26",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 56.41,
			"r": "58",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 67.3,
			"r": "45",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 87.79,
			"r": "23",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 59.97,
			"r": "55",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 67.31,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 51.94,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 42.05,
			"r": "77",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 116.8,
			"r": "7",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 17.23,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 13.93,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 15.77,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 33.85,
			"r": "95",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 107.02,
			"r": "14",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 8.47,
			"r": "127",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 59.47,
			"r": "56",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 38.98,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 54.81,
			"r": "63",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 67.53,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 1.38,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 0.16,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 95.05,
			"r": "17",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 60.18,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 122.09,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 10.02,
			"r": "123",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 40.11,
			"r": "83",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 45.65,
			"r": "73",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 291900,
			"r": "81",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 18.84,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 78.26,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 17.04,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 61.83,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 82.14,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 70.54,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 13.45,
			"r": "118",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 68.57,
			"r": "42",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 80.03,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 37.03,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 5.97,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 53.43,
			"r": "65",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 39.23,
			"r": "87",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 111.67,
			"r": "11",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 50.45,
			"r": "71",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 13.79,
			"r": "117",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 23.1,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 15.29,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 9.36,
			"r": "125",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 62.63,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 71.75,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 66.82,
			"r": "47",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 71.29,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 114.27,
			"r": "8",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 56.03,
			"r": "62",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 109.23,
			"r": "13",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 50.94,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 126.44,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 36.71,
			"r": "92",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 75.1,
			"r": "35",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 8.1,
			"r": "128",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 142.2,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 4.24,
			"r": "134",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 40.97,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 93.43,
			"r": "18",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 14.16,
			"r": "116",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 83.33,
			"r": "24",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 62.07,
			"r": "52",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 15.22,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 91.99,
			"r": "20",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 33.48,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 33.52,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 39.03,
			"r": "88",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 139.31,
			"r": "3",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 26.42,
			"r": "101",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 4.27,
			"r": "133",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 76.02,
			"r": "32",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 37.52,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 3.19,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 9.01,
			"r": "126",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 56.32,
			"r": "59",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 114.22,
			"r": "9",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 80.2,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 54.86,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.13,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 288,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 58.67,
			"r": "90",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 70.6,
			"r": "99",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 56.91,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 96,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 13.38,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 29.44,
			"r": "59",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 57.71,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 120,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 24,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 48,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 38.54,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 78,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 60,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 8.5,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 48,
			"r": "73",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 42.46,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 21,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 20.39,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 38,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 9,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.38,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 117,
			"r": "124",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 60,
			"r": "91",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 24,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 90,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 240,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 135.43,
			"r": "130",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 36,
			"r": "62",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 56.29,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 70.5,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 193,
			"r": "132",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 7.61,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 101,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 85.12,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 96,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 48,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.4,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 75,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 51,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 20,
			"r": "44",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 72,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 49.04,
			"r": "80",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 38.14,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 20,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 97.33,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 72,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 84,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 16,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 60,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 112,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 24,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 96,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 75.33,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 35.5,
			"r": "61",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 19,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 82,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 109.71,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 21,
			"r": "47",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 24,
			"r": "50",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 133,
			"r": "129",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 8,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 53.28,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 88,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 72,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 43,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 48,
			"r": "73",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 18.55,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 515.04,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 100,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 57.73,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 18,
			"r": "41",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 106,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 28,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.83,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 109.33,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 118.14,
			"r": "125",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 9,
			"r": "32",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 48.22,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 52,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 5,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 99.69,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 29.83,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 48,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 48,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 96,
			"r": "110",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 120,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 69,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 13.5,
			"r": "37",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 148,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 72,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 75,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 106.12,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 50.46,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.67,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 108,
			"r": "120",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 96,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 2,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 25.93,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "18",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 15.75,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 22.6,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 48,
			"r": "73",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 36,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 26,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 12,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 78,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 112,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 12,
			"r": "34",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 120,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 54.86,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 27,
			"r": "58",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.21,
			"r": "28",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 144,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 71.67,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 72,
			"r": "101",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 61.45,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 202,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 62,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 96,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 96,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 69.82,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 38,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 16.85,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 41,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFPEAK": {
		"UNK": null,
		"NOR": {
			"v": 8.44,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 1.09,
			"r": "50",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.79,
			"r": "41",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.27,
			"r": "30",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.51,
			"r": "60",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 2.72,
			"r": "62",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 0.73,
			"r": "39",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 9.76,
			"r": "92",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 0.26,
			"r": "29",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 0.65,
			"r": "37",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 17.46,
			"r": "134",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.95,
			"r": "65",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 1.28,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 7.84,
			"r": "87",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 4.73,
			"r": "70",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 10.38,
			"r": "97",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.26,
			"r": "72",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 0.75,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 9.81,
			"r": "94",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 1.7,
			"r": "57",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 2.91,
			"r": "64",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 22.65,
			"r": "136",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.43,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 0,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.05,
			"r": "48",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.83,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 1.2,
			"r": "51",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 11.89,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 6.03,
			"r": "75",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 0.11,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 0.48,
			"r": "36",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 10.9,
			"r": "102",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 1.27,
			"r": "53",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 7.36,
			"r": "82",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.04,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 7.64,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0.02,
			"r": "25",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 18.15,
			"r": "135",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.05,
			"r": "58",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 0.83,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 0.81,
			"r": "42",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 9.14,
			"r": "90",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 1.47,
			"r": "55",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 10.9,
			"r": "102",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 0.7,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 0.21,
			"r": "28",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.28,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.91,
			"r": "47",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0,
			"r": "1",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 10.9,
			"r": "102",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.2,
			"r": "68",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 9.83,
			"r": "96",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 5.44,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.69,
			"r": "61",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 0.89,
			"r": "46",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"r": "52",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 4.9,
			"r": "71",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 9.78,
			"r": "93",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 7.6,
			"r": "83",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0,
			"r": "1",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 11.98,
			"r": "132",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 1.09,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 10.9,
			"r": "102",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 0.27,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 10.51,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 7.72,
			"r": "86",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.27,
			"r": "30",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 17.27,
			"r": "133",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.85,
			"r": "63",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 6.69,
			"r": "80",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 3.15,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 1.62,
			"r": "56",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 10.43,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 11.37,
			"r": "130",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 9.33,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 10.48,
			"r": "99",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 6.35,
			"r": "78",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.06,
			"r": "26",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"r": "1",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.42,
			"r": "59",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 7.72,
			"r": "85",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 4.51,
			"r": "69",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 9.81,
			"r": "94",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.27,
			"r": "30",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 6.05,
			"r": "76",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 6.71,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 0.27,
			"r": "30",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0.44,
			"r": "35",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 8.62,
			"r": "89",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 5.58,
			"r": "74",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 10.87,
			"r": "101",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CUSTSERVIND": {
		"UNK": null,
		"NOR": {
			"v": 0.69,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.55,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.4,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.73,
			"r": "32",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.38,
			"r": "102",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.64,
			"r": "56",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.49,
			"r": "86",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 0.61,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 0.75,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 0.91,
			"r": "7",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.71,
			"r": "35",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0.58,
			"r": "66",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 0.36,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 0.7,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 0.53,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.47,
			"r": "90",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.59,
			"r": "65",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": null,
		"NIC": {
			"v": 0.64,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 0.23,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 0.81,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.58,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.71,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.51,
			"r": "80",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 0.42,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.45,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 0.71,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.8,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.56,
			"r": "74",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 0.82,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.73,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.31,
			"y": "2015",
			"m": 18
		},
		"NGA": {
			"v": 0.49,
			"r": "85",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 0.47,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.9,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.38,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.36,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.42,
			"r": "95",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.56,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0.47,
			"y": "2009",
			"m": 96
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2009",
			"m": 87
		},
		"EGY": {
			"v": 0.33,
			"r": "109",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 0.68,
			"r": "47",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.64,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 0.87,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 0.58,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 0.81,
			"r": "18",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0.57,
			"r": "71",
			"m": 88,
			"y": "2016"
		},
		"JOR": {
			"v": 0.68,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.7,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.32,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 0.79,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": {
			"v": 0.33,
			"y": "2009",
			"m": 104
		},
		"DOM": {
			"v": 0.56,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.21,
			"r": "117",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.41,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.62,
			"r": "59",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.38,
			"r": "105",
			"m": 94,
			"y": "2015"
		},
		"TJK": null,
		"AUS": {
			"v": 0.89,
			"r": "11",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.65,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.73,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 0.51,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 0.91,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.5,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0.62,
			"r": "59",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0.91,
			"r": "7",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.25,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 0.75,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 0.73,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.47,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.23,
			"r": "116",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 0.38,
			"r": "102",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 0.67,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 0.42,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 0.65,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.64,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.75,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 0.8,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.77,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.92,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.51,
			"r": "83",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.69,
			"r": "42",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 0.57,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.69,
			"r": "42",
			"m": 51,
			"y": "2015"
		},
		"MLI": null,
		"OMN": {
			"v": 0.54,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.38,
			"y": "2009",
			"m": 86
		},
		"ITA": {
			"v": 0.92,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.92,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.35,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 0.92,
			"r": "3",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.48,
			"r": "87",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.58,
			"r": "69",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.63,
			"r": "58",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.41,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.61,
			"r": "63",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 0.8,
			"r": "20",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.26,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.48,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"TUN": null,
		"SRB": {
			"v": 0.54,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.69,
			"r": "40",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.69,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.82,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.65,
			"r": "50",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 0.82,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.62,
			"r": "59",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 0.88,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.65,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 0.83,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.33,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 0.98,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.26,
			"r": "113",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 0.51,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 0.69,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 0.67,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": null,
		"SLE": {
			"v": 0.28,
			"r": "112",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 0.95,
			"r": "2",
			"m": 74,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 0.43,
			"r": "94",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 0.6,
			"r": "64",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": null,
		"CMR": {
			"v": 0.42,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.44,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 0.79,
			"r": "23",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.79,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 0.79,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TOTTARIFRT": {
		"UNK": null,
		"NOR": {
			"v": 2.95,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 11.82,
			"r": "120",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 9.62,
			"r": "97",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.95,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 13.03,
			"r": "121",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 9.89,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 7.08,
			"r": "86",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 7.71,
			"r": "89",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 9.65,
			"r": "98",
			"m": 96,
			"y": "2011"
		},
		"SLB": null,
		"URY": {
			"v": 8.02,
			"r": "92",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 3.4,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 4.52,
			"r": "63",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.59,
			"r": "64",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 7.58,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 3.86,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.11,
			"r": "71",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 2.96,
			"r": "44",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 9.13,
			"r": "95",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.57,
			"r": "49",
			"m": 103,
			"y": "2013"
		},
		"COK": null,
		"KEN": {
			"v": 9.59,
			"r": "96",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 6.47,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 5.02,
			"r": "68",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 4.18,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 1.74,
			"r": "35",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 3.24,
			"r": "45",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.4,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 9.7,
			"r": "101",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 16.8,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 9.68,
			"r": "100",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 10.73,
			"r": "114",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 3.53,
			"r": "48",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 27.98,
			"r": "136",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 9.92,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 13.64,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 1.04,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 16.57,
			"r": "132",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 6.85,
			"r": "85",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 5.55,
			"r": "72",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 3.98,
			"r": "57",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 11.5,
			"r": "119",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 7.44,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.65,
			"r": "50",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 9.67,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 6.16,
			"r": "77",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 10.8,
			"r": "116",
			"m": 104,
			"y": "2008"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.66,
			"r": "65",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 1.04,
			"r": "5",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 13.45,
			"r": "123",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 5.79,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 2.06,
			"r": "37",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 10.38,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 9.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 22.65,
			"r": "135",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 11.12,
			"r": "118",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 1.04,
			"r": "5",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.81,
			"r": "75",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 6.39,
			"r": "80",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.28,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 4.43,
			"r": "62",
			"m": 96,
			"y": "2013"
		},
		"DNK": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 3.95,
			"r": "53",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 17.62,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8.89,
			"r": "94",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 10.18,
			"r": "111",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 6.19,
			"r": "78",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 7.91,
			"r": "91",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 14.32,
			"r": "129",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 14.31,
			"r": "128",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 13.76,
			"r": "126",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.37,
			"r": "39",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 9.89,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 4.14,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 13.46,
			"r": "124",
			"m": 86,
			"y": "2007"
		},
		"AUT": {
			"v": 1.04,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.97,
			"r": "55",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.73,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.92,
			"r": "67",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.64,
			"r": "84",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 4.08,
			"r": "58",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 0.86,
			"r": "4",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 10.63,
			"r": "113",
			"m": 105,
			"y": "2013"
		},
		"MRT": {
			"v": 9.93,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 13.03,
			"r": "122",
			"m": 96,
			"y": "2009"
		},
		"TUN": {
			"v": 10.8,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 5.06,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 10.16,
			"r": "110",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 5.78,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 11.07,
			"r": "117",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1.38,
			"r": "33",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.02,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 2.11,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 1.82,
			"r": "36",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.83,
			"r": "41",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.03,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 9.89,
			"r": "106",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 6.36,
			"r": "79",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 2.89,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 8.18,
			"r": "93",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 6.44,
			"r": "82",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 13.83,
			"r": "127",
			"m": 104,
			"y": "2006"
		},
		"ARE": {
			"v": 3.97,
			"r": "56",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.83,
			"r": "66",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 14.6,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.96,
			"r": "54",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 9.89,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 14.56,
			"r": "130",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 4.08,
			"r": "59",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 9.84,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 7.73,
			"r": "90",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 2.81,
			"r": "40",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 1.51,
			"r": "34",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 5.04,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"HOMICIDERT": {
		"UNK": null,
		"NOR": {
			"v": 0.6,
			"r": "11",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 0.8,
			"r": "21",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 62,
			"r": "134",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 0.7,
			"r": "13",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 4,
			"r": "81",
			"m": 81,
			"y": "2014"
		},
		"BHR": {
			"v": 0.5,
			"r": "6",
			"m": 86,
			"y": "2011"
		},
		"ETH": {
			"v": 8,
			"r": "105",
			"m": 94,
			"y": "2012"
		},
		"ECU": {
			"v": 8.2,
			"r": "106",
			"m": 94,
			"y": "2014"
		},
		"FRA": {
			"v": 1.2,
			"r": "36",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 0.7,
			"r": "13",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 2.5,
			"r": "59",
			"m": 81,
			"y": "2014"
		},
		"JAM": {
			"v": 36.1,
			"r": "132",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 7.8,
			"r": "101",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 1.4,
			"r": "39",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 31.2,
			"r": "130",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 1.9,
			"r": "55",
			"m": 101,
			"y": "2010"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"r": "57",
			"m": 78,
			"y": "2013"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.6,
			"r": "75",
			"m": 100,
			"y": "2010"
		},
		"NIC": {
			"v": 11.5,
			"r": "118",
			"m": 102,
			"y": "2012"
		},
		"MKD": {
			"v": 1.6,
			"r": "46",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 1.7,
			"r": "49",
			"m": 96,
			"y": "2012"
		},
		"KHM": {
			"v": 1.8,
			"r": "51",
			"m": 97,
			"y": "2011"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 9.9,
			"r": "112",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 5.9,
			"r": "90",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 38,
			"r": "133",
			"m": 100,
			"y": "2010"
		},
		"MEX": {
			"v": 15.7,
			"r": "123",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 64.2,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 5.5,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 1.5,
			"r": "41",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 0.5,
			"r": "6",
			"m": 91,
			"y": "2013"
		},
		"CHL": {
			"v": 3.6,
			"r": "75",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 3.9,
			"r": "78",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 6.7,
			"r": "93",
			"m": 105,
			"y": "2013"
		},
		"CPV": {
			"v": 10.6,
			"y": "2013",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 9.8,
			"y": "2012",
			"m": 12
		},
		"NGA": {
			"v": 10.1,
			"r": "114",
			"m": 102,
			"y": "2012"
		},
		"PRT": {
			"v": 0.9,
			"r": "24",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 1.6,
			"r": "46",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 2.9,
			"r": "65",
			"m": 103,
			"y": "2011"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 11.8,
			"r": "119",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 3.2,
			"r": "70",
			"m": 99,
			"y": "2012"
		},
		"MNE": {
			"v": 3.2,
			"r": "70",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 4.8,
			"r": "86",
			"m": 96,
			"y": "2012"
		},
		"SPM": null,
		"MWI": {
			"v": 1.8,
			"r": "51",
			"m": 100,
			"y": "2012"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 34.4,
			"y": "2014",
			"m": 88
		},
		"EGY": {
			"v": 3.2,
			"r": "70",
			"m": 94,
			"y": "2011"
		},
		"BGR": {
			"v": 1.6,
			"r": "46",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 7.8,
			"r": "101",
			"m": 103,
			"y": "2012"
		},
		"IMN": null,
		"THA": {
			"v": 3.9,
			"r": "78",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 3.7,
			"r": "77",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 2.5,
			"y": "2012",
			"m": 100
		},
		"CHE": {
			"v": 0.5,
			"r": "6",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 24.6,
			"r": "127",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 2.3,
			"r": "58",
			"m": 96,
			"y": "2012"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 10,
			"r": "113",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 4.9,
			"r": "87",
			"m": 103,
			"y": "2010"
		},
		"ATA": null,
		"SVN": {
			"v": 0.7,
			"r": "13",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 20.4,
			"y": "2013",
			"m": 96
		},
		"SUR": {
			"v": 9.5,
			"y": "2012",
			"m": 104
		},
		"DOM": {
			"v": 17.4,
			"r": "125",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 25.9,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.2,
			"y": "2012",
			"m": 105
		},
		"PAN": {
			"v": 17.4,
			"r": "125",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 1.8,
			"r": "51",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 9.4,
			"r": "109",
			"m": 94,
			"y": "2012"
		},
		"TJK": {
			"v": 1.4,
			"r": "39",
			"m": 104,
			"y": "2013"
		},
		"AUS": {
			"v": 1,
			"r": "30",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"r": "30",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 1.5,
			"r": "41",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 2.1,
			"y": "2010",
			"m": 104
		},
		"CIV": {
			"v": 11.4,
			"r": "116",
			"m": 92,
			"y": "2012"
		},
		"ABW": null,
		"ESP": {
			"v": 0.7,
			"r": "13",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.7,
			"r": "60",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 7.6,
			"r": "100",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 0.9,
			"r": "24",
			"m": 95,
			"y": "2013"
		},
		"SXM": null,
		"KAZ": {
			"v": 7.4,
			"r": "98",
			"m": 97,
			"y": "2013"
		},
		"BWA": {
			"v": 14.8,
			"r": "122",
			"m": 91,
			"y": "2010"
		},
		"MDA": {
			"v": 3.2,
			"r": "70",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 0.5,
			"r": "6",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 1,
			"r": "30",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 74.6,
			"r": "136",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 8.7,
			"y": "2012",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.9,
			"r": "65",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 12.4,
			"r": "120",
			"m": 88,
			"y": "2012"
		},
		"NFK": null,
		"HKG": {
			"v": 0.9,
			"r": "24",
			"m": 96,
			"y": "2013"
		},
		"COD": {
			"v": 12.5,
			"r": "121",
			"m": 92,
			"y": "2012"
		},
		"ZAF": {
			"v": 33,
			"r": "131",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 1.5,
			"r": "41",
			"m": 105,
			"y": "2011"
		},
		"CYP": {
			"v": 0.1,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 1.1,
			"r": "33",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 9.2,
			"r": "108",
			"m": 104,
			"y": "2012"
		},
		"HTI": {
			"v": 10,
			"y": "2012",
			"m": 96
		},
		"IRL": {
			"v": 1.1,
			"r": "33",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 0.7,
			"r": "13",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.9,
			"r": "24",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 9.4,
			"r": "109",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.5,
			"r": "41",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 0.1,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 4,
			"r": "81",
			"m": 46,
			"y": "2014"
		},
		"MLI": {
			"v": 10.2,
			"r": "115",
			"m": 100,
			"y": "2012"
		},
		"OMN": {
			"v": 1.1,
			"r": "33",
			"m": 103,
			"y": "2011"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 17.4,
			"y": "2010",
			"m": 104
		},
		"BLR": {
			"v": 3.6,
			"y": "2014",
			"m": 86
		},
		"ITA": {
			"v": 0.8,
			"r": "21",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 0.7,
			"r": "13",
			"m": 103,
			"y": "2013"
		},
		"BGD": {
			"v": 2.8,
			"r": "64",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 0.5,
			"r": "6",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 7.2,
			"r": "96",
			"m": 103,
			"y": "2012"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.7,
			"r": "60",
			"m": 100,
			"y": "2011"
		},
		"ATG": null,
		"AFG": {
			"v": 6.6,
			"y": "2012",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 4.3,
			"r": "83",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 8.8,
			"r": "107",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 6.2,
			"r": "91",
			"m": 104,
			"y": "2012"
		},
		"GRL": null,
		"GEO": {
			"v": 2.7,
			"r": "60",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.8,
			"r": "89",
			"m": 105,
			"y": "2010"
		},
		"MRT": {
			"v": 11.4,
			"r": "116",
			"m": 100,
			"y": "2012"
		},
		"DMA": null,
		"BFA": {
			"v": 0.7,
			"y": "2012",
			"m": 84
		},
		"IND": {
			"v": 3.2,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 3.1,
			"r": "68",
			"m": 104,
			"y": "2012"
		},
		"SRB": {
			"v": 1.3,
			"r": "37",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 1.7,
			"r": "49",
			"m": 95,
			"y": "2011"
		},
		"RUS": {
			"v": 9.5,
			"r": "111",
			"m": 103,
			"y": "2014"
		},
		"EST": {
			"v": 3.1,
			"r": "68",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 0.8,
			"r": "21",
			"m": 91,
			"y": "2012"
		},
		"NIU": null,
		"USA": {
			"v": 3.9,
			"r": "78",
			"m": 105,
			"y": "2013"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.3,
			"r": "83",
			"m": 104,
			"y": "2012"
		},
		"JPN": {
			"v": 0.3,
			"r": "3",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 6.7,
			"r": "93",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 0.9,
			"r": "24",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 4.4,
			"r": "85",
			"m": 105,
			"y": "2010"
		},
		"SGP": {
			"v": 0.3,
			"r": "3",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 6.3,
			"r": "92",
			"m": 83,
			"y": "2012"
		},
		"COL": {
			"v": 27.9,
			"r": "129",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 0.3,
			"r": "3",
			"m": 96,
			"y": "2013"
		},
		"LAO": {
			"v": 7.3,
			"r": "97",
			"m": 98,
			"y": "2012"
		},
		"FLK": null,
		"LUX": {
			"v": 0.7,
			"r": "13",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 16.9,
			"r": "124",
			"m": 101,
			"y": "2012"
		},
		"SLE": {
			"v": 1.9,
			"r": "55",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.7,
			"r": "13",
			"m": 71,
			"y": "2014"
		},
		"GNB": null,
		"BIH": {
			"v": 1.3,
			"r": "37",
			"m": 86,
			"y": "2014"
		},
		"MMR": {
			"v": 2.5,
			"y": "2012",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 6.7,
			"r": "93",
			"m": 105,
			"y": "2012"
		},
		"KWT": {
			"v": 1.8,
			"r": "51",
			"m": 97,
			"y": "2012"
		},
		"ESH": null,
		"SEN": {
			"v": 7.9,
			"r": "103",
			"m": 104,
			"y": "2012"
		},
		"CMR": {
			"v": 2.7,
			"r": "60",
			"m": 92,
			"y": "2012"
		},
		"MNG": {
			"v": 7.5,
			"r": "99",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 3.7,
			"y": "2010",
			"m": 104
		},
		"TZA": {
			"v": 7.9,
			"r": "103",
			"m": 104,
			"y": "2012"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.6,
			"r": "11",
			"m": 100,
			"y": "2010"
		},
		"BLM": null,
		"CAN": {
			"v": 1.5,
			"r": "41",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 0.9,
			"r": "24",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 3,
			"r": "67",
			"m": 104,
			"y": "2011"
		},
		"BRB": {
			"v": 8.8,
			"y": "2014",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"LINERSHIPIDX": {
		"UNK": null,
		"NOR": {
			"v": 5.89,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 32.51,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 8.46,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": {
			"v": 26.48,
			"r": "55",
			"m": 86,
			"y": "2016"
		},
		"ETH": null,
		"ECU": {
			"v": 31.36,
			"r": "49",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 83.9,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 115.61,
			"r": "3",
			"m": 97,
			"y": "2016"
		},
		"AZE": null,
		"JAM": {
			"v": 20.05,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 34.93,
			"r": "45",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 57.68,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 20.3,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 106.79,
			"r": "4",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": {
			"v": 9.51,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 8.84,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"MKD": null,
		"ISR": {
			"v": 37.36,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.61,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 17.81,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 13.66,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 50.88,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 8.93,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.22,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 29.89,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.86,
			"r": "101",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 36.3,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.62,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 5.76,
			"r": "91",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.1,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 29.67,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 21.93,
			"r": "59",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 48.16,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 9.64,
			"r": "77",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": {
			"v": 7.78,
			"r": "85",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.19,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 24.63,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 7.8,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 62.5,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.86,
			"r": "98",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 36.58,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 44.32,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"KGZ": null,
		"LBY": {
			"v": 4.86,
			"y": "2016",
			"m": 100
		},
		"CHE": null,
		"MAC": null,
		"BRA": {
			"v": 39.93,
			"r": "37",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 29.27,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 11.49,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 33.23,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.52,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 4.98,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 24.55,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 17.39,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 53.42,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 88.64,
			"r": "10",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 9.38,
			"r": "80",
			"m": 94,
			"y": "2016"
		},
		"TJK": null,
		"AUS": {
			"v": 30.64,
			"r": "50",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 64.72,
			"r": "17",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": null,
		"SYC": {
			"v": 7.92,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 22.01,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 86.13,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 36.38,
			"r": "42",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 97.23,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 27.19,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 54.85,
			"r": "24",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 9.96,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 8.92,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 63.21,
			"r": "18",
			"m": 100,
			"y": "2016"
		},
		"BOL": null,
		"NFK": null,
		"HKG": {
			"v": 101.02,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 4.07,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 37.1,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 62.84,
			"r": "19",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 19.32,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": {
			"v": 6.31,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 9.49,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 52.5,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 58.84,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 6.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.55,
			"r": "94",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 47.41,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "103",
			"m": 62,
			"y": "2016"
		},
		"MLI": null,
		"OMN": {
			"v": 47.35,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 67.41,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 95.73,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 12.62,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"AUT": null,
		"QAT": {
			"v": 5.2,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 28.64,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 35.1,
			"r": "44",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 61.79,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.73,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": {
			"v": 6.26,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 46.24,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 5.35,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.96,
			"y": "2007",
			"m": 104
		},
		"GHA": {
			"v": 20.7,
			"r": "61",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 42.57,
			"r": "36",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.4,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 167.48,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 98.7,
			"r": "6",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 49.61,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 78.9,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 37.8,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 97.75,
			"r": "7",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 31.37,
			"r": "48",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 122.7,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 18.34,
			"r": "65",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 52.98,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.36,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": {
			"v": 14.32,
			"r": "69",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 7.61,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 70.57,
			"r": "15",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": null,
		"MMR": {
			"v": 6.37,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 8.89,
			"r": "82",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 12.77,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 15.01,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MNG": null,
		"TLS": null,
		"TZA": {
			"v": 9.67,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 10.73,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 42.64,
			"r": "35",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 20.81,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 75.75,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.92,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"BBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 38.94,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 23.18,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 8.24,
			"r": "73",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 27.9,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.03,
			"r": "131",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 18.61,
			"r": "47",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.66,
			"r": "111",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 9.17,
			"r": "71",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 41.34,
			"r": "4",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 40.25,
			"r": "5",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 19.76,
			"r": "44",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 5.83,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 26.27,
			"r": "33",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 37.85,
			"r": "7",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.83,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 8.95,
			"r": "72",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 9.58,
			"r": "69",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0.08,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 1.86,
			"r": "98",
			"m": 102,
			"y": "2015"
		},
		"MKD": {
			"v": 17.19,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 27.44,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 0.53,
			"r": "113",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.4,
			"r": "91",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 0.28,
			"r": "117",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 0.1,
			"r": "125",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 11.65,
			"r": "64",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 5.49,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 27.79,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 19.77,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 7.99,
			"r": "75",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 15.17,
			"r": "56",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 25.09,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 1.55,
			"r": "102",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 3.26,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.67,
			"y": "2015",
			"m": 17
		},
		"NGA": {
			"v": 0.01,
			"r": "133",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 29.62,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 31.7,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.06,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.32,
			"r": "116",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.16,
			"r": "123",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 18.08,
			"r": "49",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 10.86,
			"r": "67",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 0,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 4.52,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 22.41,
			"r": "40",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 0.95,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 9.24,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.71,
			"r": "89",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 0.97,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 44.79,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 12.24,
			"r": "61",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 4.16,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 11.17,
			"r": "65",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.17,
			"r": "122",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 27.63,
			"r": "29",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 6.65,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 9.61,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 6.44,
			"r": "79",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 20.68,
			"r": "42",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 6.02,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 7.93,
			"r": "76",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 36.85,
			"r": "11",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.63,
			"r": "112",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 0.07,
			"r": "128",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 27.85,
			"r": "26",
			"m": 79,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.38,
			"r": "92",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 27.43,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 14.31,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 0.52,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 28.31,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.56,
			"r": "90",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 16.08,
			"r": "53",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 37.72,
			"r": "8",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 13.05,
			"r": "58",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 1.79,
			"r": "99",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 15.55,
			"r": "55",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 1.09,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 42.51,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.34,
			"r": "97",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 0.01,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 3.1,
			"r": "94",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 1.64,
			"r": "101",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 31.94,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "135",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 5.25,
			"r": "85",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 8.14,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 22.38,
			"r": "41",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 23.34,
			"r": "37",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0.08,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 0.01,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 27.71,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 19.47,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 36.07,
			"r": "14",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0.18,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.57,
			"r": "83",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 30.73,
			"r": "19",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 7.6,
			"r": "77",
			"m": 49,
			"y": "2015"
		},
		"MLI": {
			"v": 0.02,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 5.61,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.47,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 31.36,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 23.8,
			"r": "36",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 41.73,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.41,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 28.58,
			"r": "23",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 10.06,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 15.74,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 0.33,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 22.76,
			"r": "39",
			"m": 98,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.14,
			"r": "93",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 12.01,
			"r": "62",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 14.63,
			"r": "57",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 0.15,
			"r": "124",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 0.24,
			"r": "119",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 0.04,
			"y": "2015",
			"m": 85
		},
		"IND": {
			"v": 1.34,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 4.34,
			"r": "87",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 16.75,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.28,
			"r": "118",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 18.77,
			"r": "46",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 28.68,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 18.56,
			"r": "48",
			"m": 91,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 31.53,
			"r": "18",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 12.39,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 30.49,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 6.42,
			"r": "80",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 37.19,
			"r": "9",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 11.81,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 26.45,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0.67,
			"r": "109",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 11.16,
			"r": "66",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 36.95,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 0.52,
			"r": "114",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 36.48,
			"r": "12",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 1.72,
			"r": "100",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "134",
			"m": 104,
			"y": "2007"
		},
		"ARE": {
			"v": 12.81,
			"r": "59",
			"m": 73,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 16.62,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 0.06,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.09,
			"r": "105",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 1.37,
			"r": "103",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0.67,
			"r": "110",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0.07,
			"r": "129",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 7.12,
			"r": "78",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 0.09,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 0.2,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.07,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 36.41,
			"r": "13",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 31.55,
			"r": "17",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 24.26,
			"r": "35",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 27.23,
			"y": "2015",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"inv_community": {
		"UNK": null,
		"NOR": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.6,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.25,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.6,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.25,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.5,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.25,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.8,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.33,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.75,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.4,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.6,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.75,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.6,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.6,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.25,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 0.75,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.6,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.6,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.25,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.25,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.5,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.8,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.4,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.6,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.5,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.67,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.8,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 8": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 11": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 1": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 2": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"DBENFORCECONTRACTS": {
		"UNK": null,
		"NOR": {
			"v": 78.99,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 75.87,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 48.97,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 60.36,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 45.74,
			"r": "114",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 54.53,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 59.06,
			"r": "66",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 56.68,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 73.04,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 84.15,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 65.66,
			"r": "40",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 53.6,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 54.44,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 62.17,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 34.55,
			"r": "130",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 66.61,
			"r": "39",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 69.71,
			"r": "27",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 27.32,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 58.58,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 67.79,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 57.93,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 32.67,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 49.24,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 58.27,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 57.18,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 67.01,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 55.2,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 77.88,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 71.08,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 57.25,
			"r": "76",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 62.81,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 71.66,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 48.52,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 65.76,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 26.26,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 48.59,
			"r": "107",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 73.01,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 69.4,
			"r": "29",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 45.26,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 60.6,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 33.92,
			"r": "132",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 66.75,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 60,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 46.48,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 50.11,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 40.9,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 65.09,
			"r": "43",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 43.49,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 64.54,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 48.57,
			"r": "109",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 48.41,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 67.1,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 67.41,
			"r": "35",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 52.42,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 52.41,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 56.76,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 52.97,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 57.62,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 25.94,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 51.03,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 36.55,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 67.26,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 48.1,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 64.25,
			"r": "46",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 32.84,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 63.49,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 79.72,
			"r": "3",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 62.34,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 75.79,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 51.25,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 55.74,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 69.48,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 65.36,
			"r": "41",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 64.81,
			"r": "44",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 69.36,
			"r": "30",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 75.7,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 50.95,
			"r": "102",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 60.87,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 38.15,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 71.23,
			"r": "24",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 45.54,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 53.87,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 39.31,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 51.57,
			"r": "100",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 72.57,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 36.06,
			"r": "128",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 54.1,
			"r": "91",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 60.22,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 48.59,
			"r": "107",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 58.92,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 44.58,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 52.49,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 57.88,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 63.44,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 72.04,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 54.84,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 55.49,
			"r": "83",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 50.19,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 53.66,
			"r": "93",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 43.73,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 61.55,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 33.94,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 70.36,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 54.79,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 59.94,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 22.21,
			"r": "136",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 75.49,
			"r": "10",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 52.79,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 68.65,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 31.76,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 51.7,
			"r": "99",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 59.77,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 55.07,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 73.21,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 49.89,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 58.58,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 41.05,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 35.19,
			"r": "129",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 59.33,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 61.41,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 54,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 74.96,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 75.16,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 77.98,
			"r": "5",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 72.61,
			"r": "20",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 68.87,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 65.26,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 60.7,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 73.17,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 58.96,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 83.61,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 36.34,
			"r": "127",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 34.29,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 69.1,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 58.07,
			"r": "73",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 73.32,
			"r": "15",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 56.03,
			"r": "80",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 55.92,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 71.14,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 60.6,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 24.53,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 38.73,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 60.51,
			"r": "59",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 48.15,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 41.76,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 58.48,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 6.13,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 61.66,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 42.85,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 54.35,
			"r": "90",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 74.25,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 73.49,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 38.02,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"adv_rulings": {
		"UNK": null,
		"NOR": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.57,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.14,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.33,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 0.86,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.3,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 2,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.14,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.43,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.11,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.29,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.57,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.44,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.86,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.67,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.29,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.33,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.3,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.62,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.33,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.86,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.83,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.57,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.33,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.3,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.29,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.86,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.33,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.56,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.33,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.83,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.14,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 0.33,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.86,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.57,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 1.56,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.62,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.29,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.71,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.44,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 2,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1.17,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.8,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.56,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.29,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.29,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.33,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.4,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.33,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.3,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 0,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.86,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.86,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.75,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.2,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.86,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.86,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 3.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 1.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 2.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 1.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 6.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 1.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 400,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1025,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 130,
			"r": "81",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 750,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 75,
			"r": "55",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 26.75,
			"r": "32",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 200,
			"r": "103",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 90,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 285,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 140,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 60,
			"r": "49",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "68",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 171,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 86.11,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 50,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 70,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 120,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 115,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 90,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 100,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 66.67,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 125,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 460,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 564.29,
			"r": "128",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 295.62,
			"r": "113",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 527.5,
			"r": "125",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 100,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 196.67,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 161.54,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 75,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 1000,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 785.71,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 43.45,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 200,
			"r": "103",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 60,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 75,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 106.94,
			"r": "74",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 30,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 75,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 121.07,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 63,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 40,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 40,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 250,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 292,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 170,
			"r": "96",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 260,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 100,
			"r": "68",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 116.44,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 93,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 266.67,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 120,
			"r": "78",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 66.62,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 41.11,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 164.4,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 70,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 180,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 282.78,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 30,
			"r": "33",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 56.8,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 875,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 213.33,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 182.5,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 500,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 150,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 75,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 151.88,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 399.78,
			"r": "120",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "30",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 375,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 20,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 76,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 370,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 616.89,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 165.62,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 900,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 135,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 135,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 390.38,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 189,
			"r": "101",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 175,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 400,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 197,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 134.83,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 144.44,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 35,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 474,
			"r": "123",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 152.5,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 170.89,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 100,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 141.62,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 100,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 212,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 40,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 529,
			"r": "126",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 115,
			"r": "75",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 62.5,
			"r": "50",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 387.14,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 283.33,
			"r": "111",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 96.5,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 210,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 150,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 331.82,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 545,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 849,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 82.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 115,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 375,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 149.55,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 162.5,
			"r": "93",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 90.15,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 146,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"form_proc": {
		"UNK": null,
		"NOR": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.27,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 0.94,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 1,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.41,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.36,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.13,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.44,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.5,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.7,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1.1,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 0.87,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.47,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0.79,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.12,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.31,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.8,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.36,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.86,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.75,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 0.88,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.47,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.73,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.88,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.33,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.41,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.47,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.85,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.12,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.55,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.93,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.38,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.62,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.31,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.27,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.35,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.47,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.22,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.38,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.56,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.07,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.25,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.62,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.27,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.35,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.13,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.12,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.14,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.89,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.4,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.22,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.47,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 0.89,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.27,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.75,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.07,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.8,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.31,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.44,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.18,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.41,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.69,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.2,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1.36,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.44,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.07,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.18,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.14,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.53,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.87,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 0.93,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.25,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.69,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.27,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.47,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.53,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.07,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 0.73,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.06,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.27,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.18,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.69,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.38,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.31,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.12,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.12,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.07,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.2,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.79,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.88,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.81,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.3,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.64,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.87,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.88,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"NETUSERPCT": {
		"UNK": null,
		"NOR": {
			"v": 96.81,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 69.8,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 61.87,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 81.3,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 4.87,
			"r": "132",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 93.48,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.6,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 48.94,
			"r": "80",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 84.69,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 89.9,
			"r": "13",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 77,
			"r": "33",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 43.18,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 64.6,
			"r": "57",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 76.18,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 27.1,
			"r": "98",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 71.06,
			"r": "45",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 58.25,
			"r": "64",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 9,
			"r": "128",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 19.7,
			"r": "112",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 70.38,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 78.89,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 19,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 40.7,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 45.62,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 16.07,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 57.43,
			"r": "65",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 26.92,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 71.38,
			"r": "43",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 55.76,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 71.2,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 64.29,
			"r": "59",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 79.2,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 25.1,
			"r": "101",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 43.02,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 12.4,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 47.44,
			"r": "82",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 68.63,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 92.65,
			"r": "9",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 17.58,
			"r": "119",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 19.22,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 5.9,
			"r": "130",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 64.56,
			"r": "58",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 44.08,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 9.3,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 41.59,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 35.9,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 56.66,
			"r": "67",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 18,
			"r": "117",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 39.32,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 30.25,
			"r": "95",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 19.02,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 87.97,
			"r": "18",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 59.08,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 53.4,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 59.76,
			"r": "62",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 18,
			"r": "117",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 73.1,
			"r": "39",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 38.2,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 42.76,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 51.93,
			"r": "73",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 69.2,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 42.8,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 51.21,
			"r": "75",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 85.05,
			"r": "20",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 23.5,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 18.98,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 84.56,
			"r": "24",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 57.08,
			"r": "66",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 72.83,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 58.12,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 21,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 78.69,
			"r": "32",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 39.8,
			"r": "91",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 69.4,
			"r": "49",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 92,
			"r": "10",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 72.87,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 27.5,
			"r": "97",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 49.84,
			"r": "78",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 21.98,
			"r": "105",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 96.33,
			"r": "4",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 20.36,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 4.7,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 29.99,
			"r": "96",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 45.1,
			"r": "85",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 84.95,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.8,
			"r": "134",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 51.92,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 52.72,
			"r": "72",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 71.72,
			"r": "42",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 85.02,
			"r": "21",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.7,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 12.2,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 80.12,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 68,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 90.61,
			"r": "12",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 17.12,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 38.2,
			"r": "93",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 66.83,
			"r": "53",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 63.25,
			"r": "60",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 10.34,
			"r": "126",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 74.17,
			"r": "36",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 30.38,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 62.23,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 65.57,
			"r": "54",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 93.1,
			"r": "7",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 14.4,
			"r": "124",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 83.93,
			"r": "25",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 92.88,
			"r": "8",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 50.14,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 8.26,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 74,
			"r": "37",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 44.38,
			"r": "86",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 69.62,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 45.16,
			"r": "84",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 21,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 15.2,
			"r": "123",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 11.39,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 26,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 48.52,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 65.32,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 23.48,
			"r": "103",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 73.41,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 88.41,
			"r": "15",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 50.3,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 74.55,
			"r": "35",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 53.74,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 93.33,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 40.9,
			"r": "89",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 87.59,
			"r": "19",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 49.26,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 82.1,
			"r": "26",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 6.79,
			"r": "129",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 55.9,
			"r": "68",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 98.2,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 18.2,
			"r": "116",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 97.33,
			"r": "2",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 22.31,
			"r": "104",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.5,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 91.24,
			"r": "11",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 65.07,
			"r": "56",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 21.8,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 16.36,
			"r": "121",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 82.08,
			"r": "27",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 21.69,
			"r": "106",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 20.68,
			"r": "110",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 21.44,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 13.4,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 5.36,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.17,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 88.47,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 88.22,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 87.98,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 76.11,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0401": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ061": {
		"UNK": null,
		"NOR": {
			"v": 5.84,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.14,
			"r": "78",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.69,
			"r": "129",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.34,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.59,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.87,
			"r": "46",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.14,
			"r": "39",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.87,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.69,
			"r": "21",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.32,
			"r": "36",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.02,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.44,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.56,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.87,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.7,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.38,
			"r": "67",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.56,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.41,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.55,
			"r": "109",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.78,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.4,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.85,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.25,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.84,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 1.05,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.58,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.3,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.36,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.75,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.08,
			"r": "84",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.85,
			"r": "47",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.14,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.22,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.74,
			"r": "102",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.3,
			"r": "117",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.2,
			"r": "119",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.44,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.24,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.65,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.19,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.25,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.1,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.43,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.36,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 4.39,
			"r": "76",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 4.77,
			"r": "52",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.14,
			"r": "77",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.99,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.95,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.88,
			"r": "126",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.42,
			"r": "139",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.11,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.92,
			"r": "95",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.33,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.61,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.65,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.34,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.83,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.64,
			"r": "104",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.81,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.28,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 5.28,
			"r": "44",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 6.21,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.22,
			"r": "125",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.7,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.62,
			"r": "108",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.34,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.28,
			"r": "37",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.73,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.3,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.91,
			"r": "47",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 5.24,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.85,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.69,
			"r": "104",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.06,
			"r": "87",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.76,
			"r": "18",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.01,
			"r": "90",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.01,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.92,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.52,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.83,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.08,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.49,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.62,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.91,
			"r": "96",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.62,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.78,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.99,
			"r": "10",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.06,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.92,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.43,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.95,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.89,
			"r": "127",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.57,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.32,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.68,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.13,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.24,
			"r": "117",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.94,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.36,
			"r": "68",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.51,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.74,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.56,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.6,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.46,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.25,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "35",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.2,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.75,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.09,
			"r": "82",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.64,
			"r": "132",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.88,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.04,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.18,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.38,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.03,
			"r": "126",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.49,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.87,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.95,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.95,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "65",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.45,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.81,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.09,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.41,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.59,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.89,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.72,
			"r": "103",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.85,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.23,
			"r": "118",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.21,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.96,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.77,
			"r": "100",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.47,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.63,
			"r": "57",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.69,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.75,
			"r": "2",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.6,
			"r": "133",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.62,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.63,
			"r": "107",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.64,
			"r": "106",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.06,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.66,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.11,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.16,
			"r": "143",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.17,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.17,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.84,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.66,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.33,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.34,
			"r": "32",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC04": {
		"UNK": null,
		"NOR": {
			"v": 3.7,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.66,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.42,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.11,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.42,
			"r": "123",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.04,
			"r": "40",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.23,
			"r": "80",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "48",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.13,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.71,
			"r": "11",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.99,
			"r": "42",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.38,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.09,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.86,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.7,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.02,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.87,
			"r": "98",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.64,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.73,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.31,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.16,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.57,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.55,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.33,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.24,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.2,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.15,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.94,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.98,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.39,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 3.9,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.72,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.12,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.55,
			"r": "117",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.75,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.89,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.06,
			"r": "135",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.57,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.67,
			"r": "107",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.73,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.49,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.4,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.73,
			"r": "56",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 3.12,
			"r": "85",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.17,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.18,
			"r": "132",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.33,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.22,
			"r": "82",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.59,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.57,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.28,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.64,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.82,
			"r": "54",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.01,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.51,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.25,
			"r": "15",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.49,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.01,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.87,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.33,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.63,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.67,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.09,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.21,
			"r": "131",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.41,
			"r": "73",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.73,
			"r": "10",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.53,
			"r": "67",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.52,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.59,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.88,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.11,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.91,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.48,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.4,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.03,
			"r": "136",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.52,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.84,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.67,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.42,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.11,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.88,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.81,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.22,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3,
			"r": "92",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.86,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 2.64,
			"r": "111",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.63,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.5,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.79,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.04,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.66,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.7,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.63,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.74,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.19,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.67,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.5,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.35,
			"r": "76",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.79,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.22,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.53,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.96,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.92,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 2.85,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.14,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 3.84,
			"r": "53",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.58,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.08,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.54,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.1,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.96,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.05,
			"r": "8",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.43,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.69,
			"r": "106",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.96,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.94,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.41,
			"r": "125",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.58,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.87,
			"r": "49",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.55,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.34,
			"r": "2",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.36,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.07,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.43,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.42,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.37,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.75,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.16,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.29,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.03,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.22,
			"r": "16",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA01": {
		"UNK": null,
		"NOR": {
			"v": 5.22,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.43,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.81,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.41,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.88,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.22,
			"r": "59",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.34,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.2,
			"r": "106",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.34,
			"r": "46",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.73,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.3,
			"r": "102",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.28,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.95,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.21,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.09,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.35,
			"r": "43",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.42,
			"r": "99",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.91,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.92,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 5.52,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.73,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.19,
			"r": "107",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.57,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.17,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.93,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.88,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.36,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.42,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 6.02,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 6.41,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.39,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.47,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.7,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.41,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.36,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.9,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.73,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.33,
			"r": "129",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.64,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.39,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.83,
			"r": "83",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.83,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5.39,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.01,
			"r": "133",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.67,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.62,
			"r": "122",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 4.6,
			"r": "90",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.97,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.9,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.9,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.78,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.38,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 5.17,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.34,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.98,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.29,
			"r": "53",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.51,
			"r": "125",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.45,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.82,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.57,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.37,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.79,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.29,
			"r": "52",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.11,
			"r": "108",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.24,
			"r": "105",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.21,
			"r": "60",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.85,
			"r": "111",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.38,
			"r": "38",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 5.16,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.41,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.3,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 5.8,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.76,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.55,
			"r": "92",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.56,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.95,
			"r": "76",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.94,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.34,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.42,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.28,
			"r": "130",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.35,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.28,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.41,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.69,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.33,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "8",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.26,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.46,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.28,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.19,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.37,
			"r": "127",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.43,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.05,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.15,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.47,
			"r": "96",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.16,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.89,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.93,
			"r": "9",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.94,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.75,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.84,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.98,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.6,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.86,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.85,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.4,
			"r": "34",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.26,
			"r": "56",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.69,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.34,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.83,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.47,
			"r": "24",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.97,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.78,
			"r": "116",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 5.16,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.68,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.16,
			"r": "67",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.4,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.34,
			"r": "45",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.06,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.09,
			"r": "70",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.26,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.51,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.16,
			"r": "66",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.75,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.02,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.47,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.63,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.5,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.08,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.96,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"appeal_proc": {
		"UNK": null,
		"NOR": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.25,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.38,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.12,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.57,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.5,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.62,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.5,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.38,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.38,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.14,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.38,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0.88,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 2,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.43,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.17,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.62,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1.29,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.29,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.57,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.86,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.88,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.75,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.62,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.67,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0.88,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.43,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.62,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.88,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.14,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.25,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.17,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.12,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.12,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.38,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.75,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.38,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.62,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.71,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.5,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.75,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.57,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.12,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 0.88,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.14,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.88,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EXPTIMECOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CLEAREFF": {
		"UNK": null,
		"NOR": {
			"v": 3.57,
			"r": "20",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.07,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 1.99,
			"r": "126",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.58,
			"r": "19",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.02,
			"r": "123",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.14,
			"r": "41",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.6,
			"r": "78",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.64,
			"r": "74",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.71,
			"r": "17",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.45,
			"r": "26",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "79",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.37,
			"r": "99",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.78,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.78,
			"r": "60",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.47,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.17,
			"r": "40",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.95,
			"r": "129",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.49,
			"r": "85",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.48,
			"r": "86",
			"m": 102,
			"y": "2015"
		},
		"MKD": {
			"v": 2.21,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.5,
			"r": "23",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.62,
			"r": "76",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.61,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.17,
			"r": "39",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.91,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 2.88,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.37,
			"r": "97",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.42,
			"r": "28",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3,
			"r": "50",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.78,
			"r": "58",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.19,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.11,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 1.62,
			"r": "136",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.8,
			"y": "2015",
			"m": 17
		},
		"NGA": {
			"v": 2.46,
			"r": "88",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.37,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.01,
			"r": "4",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.93,
			"r": "130",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.97,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "121",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.22,
			"r": "111",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.33,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "57",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 2.75,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.4,
			"r": "91",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.66,
			"r": "72",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.11,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1.8,
			"r": "135",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 1.88,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.88,
			"r": "10",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 2.76,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.55,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.33,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.93,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 2.88,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.4,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.39,
			"r": "94",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.38,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.32,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.13,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 3.83,
			"r": "13",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.07,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 1.93,
			"r": "130",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.54,
			"r": "22",
			"m": 79,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.22,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.02,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.48,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.21,
			"r": "114",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.63,
			"r": "75",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.98,
			"r": "5",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.52,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.05,
			"r": "48",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.39,
			"r": "92",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.69,
			"r": "70",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.82,
			"r": "14",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.21,
			"r": "112",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.28,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.56,
			"r": "81",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 1.97,
			"r": "127",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 3.94,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.22,
			"r": "109",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.6,
			"r": "18",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.75,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.11,
			"r": "44",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.28,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.08,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.47,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.27,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 3.92,
			"r": "8",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.06,
			"r": "122",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.37,
			"r": "98",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.85,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.23,
			"r": "108",
			"m": 50,
			"y": "2015"
		},
		"MLI": {
			"v": 2.45,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 2.76,
			"r": "62",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.06,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.45,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.12,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.57,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.79,
			"r": "15",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.55,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.25,
			"r": "106",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.01,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.73,
			"r": "67",
			"m": 98,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.38,
			"r": "95",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 2.69,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.26,
			"r": "105",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.25,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2.14,
			"r": "117",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.55,
			"y": "2015",
			"m": 85
		},
		"IND": {
			"v": 3.17,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 1.96,
			"r": "128",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.5,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.46,
			"r": "89",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.01,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.41,
			"r": "29",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.32,
			"r": "31",
			"m": 91,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.75,
			"r": "16",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.18,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.85,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.76,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.12,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.3,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.18,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.2,
			"r": "116",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.21,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.13,
			"r": "43",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 1.85,
			"r": "134",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 3.9,
			"r": "9",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.65,
			"r": "73",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.91,
			"r": "133",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.84,
			"r": "12",
			"m": 73,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.69,
			"r": "68",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.43,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2,
			"r": "125",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 2.83,
			"r": "56",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.31,
			"r": "103",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.09,
			"r": "118",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.39,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.78,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.33,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.95,
			"r": "6",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.18,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.23,
			"r": "34",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"IMPTIMECOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI": {
		"UNK": null,
		"NOR": {
			"v": 5.27,
			"r": "17",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.76,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.85,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.12,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.41,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.79,
			"r": "42",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.72,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.14,
			"r": "81",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.37,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.04,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.3,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.03,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.37,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.95,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.32,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.9,
			"r": "37",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.32,
			"r": "68",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.88,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.24,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.52,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.99,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.96,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.13,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.2,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.15,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.55,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.25,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.01,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.61,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.27,
			"r": "72",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.26,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.86,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.95,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.25,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.01,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.6,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.11,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.53,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.46,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.16,
			"r": "132",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.93,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.72,
			"r": "116",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.54,
			"r": "53",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.51,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.45,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.76,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.45,
			"r": "11",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.8,
			"r": "110",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.73,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.52,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.59,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.96,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.2,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.86,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.52,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.45,
			"r": "10",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.24,
			"r": "129",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.1,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.6,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.89,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.87,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.28,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "92",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.98,
			"r": "94",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.52,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.05,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.41,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.2,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.3,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.42,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.08,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.9,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.78,
			"r": "112",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.66,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.03,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.52,
			"r": "55",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.26,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.61,
			"r": "47",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.93,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.93,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.27,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.96,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.61,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.95,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.51,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.55,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.51,
			"r": "60",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.71,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.67,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.91,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.7,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.48,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.52,
			"r": "7",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.78,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.89,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.03,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.86,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.33,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.8,
			"r": "41",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.97,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.18,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 3.91,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.02,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.41,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.93,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.32,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.24,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.52,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.28,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.54,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.49,
			"r": "9",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.97,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.97,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.48,
			"r": "124",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.1,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.27,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.98,
			"r": "93",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.63,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.25,
			"r": "75",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.25,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.23,
			"r": "23",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.12,
			"r": "83",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.4,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.07,
			"r": "87",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.97,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.2,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.66,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.74,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.15,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.27,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.92,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ058": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.73,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.48,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"BDI": null,
		"BHR": null,
		"ETH": {
			"v": 3.4,
			"r": "53",
			"m": 94,
			"y": "2016"
		},
		"ECU": null,
		"FRA": {
			"v": 5.84,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.52,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.15,
			"r": "31",
			"m": 81,
			"y": "2016"
		},
		"JAM": null,
		"SLB": null,
		"URY": {
			"v": 1.23,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": {
			"v": 5.06,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.74,
			"r": "75",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.99,
			"r": "57",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.43,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"NIC": null,
		"MKD": {
			"v": 2.74,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.48,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 1.62,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.97,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.84,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 2.91,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"SLV": null,
		"CYM": null,
		"LTU": {
			"v": 4.46,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.4,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"BRN": null,
		"CHL": {
			"v": 2.39,
			"r": "93",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.08,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1.48,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.16,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.66,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.59,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.76,
			"r": "74",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.91,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.48,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.42,
			"r": "125",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.61,
			"r": "82",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.08,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2.52,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.37,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.57,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.89,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2.53,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.76,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 2.97,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.42,
			"r": "24",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.25,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.89,
			"r": "58",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.88,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.96,
			"r": "39",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.92,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.55,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.59,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 2.13,
			"r": "101",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.26,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.24,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.7,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.82,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.7,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.42,
			"r": "122",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.59,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.91,
			"r": "108",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.36,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 1.54,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.8,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.15,
			"r": "58",
			"m": 105,
			"y": "2016"
		},
		"CYP": null,
		"TCA": null,
		"SVK": {
			"v": 4.58,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 3.98,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.34,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.97,
			"r": "64",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.84,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 1.35,
			"r": "130",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.19,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.1,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.11,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.64,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.65,
			"r": "81",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 2.99,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.85,
			"r": "41",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.97,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 1.83,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.48,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.81,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.15,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 1.77,
			"r": "113",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.02,
			"r": "35",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.07,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.03,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.66,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 1.92,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.36,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "36",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.74,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 1.56,
			"r": "119",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 1.4,
			"r": "128",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 5.06,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.24,
			"r": "55",
			"m": 102,
			"y": "2016"
		},
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": {
			"v": 2.05,
			"r": "102",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 1.79,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.28,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"KWT": null,
		"ESH": null,
		"SEN": {
			"v": 2.17,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.36,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.73,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.53,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.83,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.41,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.39,
			"r": "10",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ394": {
		"UNK": null,
		"NOR": {
			"v": 6.18,
			"r": "14",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 5.65,
			"r": "34",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 1.95,
			"r": "142",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 5.6,
			"r": "36",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 3.77,
			"r": "103",
			"m": 81,
			"y": "2013"
		},
		"BHR": {
			"v": 5.33,
			"r": "42",
			"m": 86,
			"y": "2014"
		},
		"ETH": {
			"v": 4.35,
			"r": "86",
			"m": 94,
			"y": "2014"
		},
		"ECU": {
			"v": 4.6,
			"r": "69",
			"m": 94,
			"y": "2013"
		},
		"FRA": {
			"v": 5.84,
			"r": "25",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 5.96,
			"r": "24",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 4.89,
			"r": "56",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 4.02,
			"r": "94",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 4.22,
			"r": "89",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 5.74,
			"r": "32",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 4.82,
			"r": "58",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 5.59,
			"r": "37",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.73,
			"r": "65",
			"m": 78,
			"y": "2014"
		},
		"PRI": {
			"v": 6.41,
			"r": "5",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.15,
			"r": "125",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 3.46,
			"r": "112",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.33,
			"r": "87",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 5.33,
			"r": "41",
			"m": 96,
			"y": "2014"
		},
		"KHM": {
			"v": 3.16,
			"r": "124",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.44,
			"r": "113",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 3.86,
			"r": "100",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 4.36,
			"r": "85",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 3.66,
			"r": "109",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 4.58,
			"r": "74",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 5.49,
			"r": "39",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 4.38,
			"r": "83",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 4.51,
			"r": "75",
			"m": 91,
			"y": "2013"
		},
		"CHL": {
			"v": 5.1,
			"r": "47",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 5.08,
			"r": "49",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 3.29,
			"r": "121",
			"m": 105,
			"y": "2014"
		},
		"CPV": {
			"v": 4.39,
			"r": "82",
			"m": 92,
			"y": "2014"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.9,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.88,
			"r": "132",
			"m": 102,
			"y": "2014"
		},
		"PRT": {
			"v": 6.2,
			"r": "12",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 6.45,
			"r": "4",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 3.42,
			"r": "115",
			"m": 103,
			"y": "2014"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.54,
			"r": "110",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 3.31,
			"r": "119",
			"m": 99,
			"y": "2013"
		},
		"MNE": {
			"v": 4.73,
			"r": "64",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 4.7,
			"r": "69",
			"m": 96,
			"y": "2014"
		},
		"SPM": null,
		"MWI": {
			"v": 3.9,
			"r": "98",
			"m": 100,
			"y": "2014"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.92,
			"r": "96",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 4.71,
			"r": "68",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 4.24,
			"r": "88",
			"m": 103,
			"y": "2014"
		},
		"IMN": null,
		"THA": {
			"v": 5.15,
			"r": "45",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 3.69,
			"r": "106",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 1.36,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.51,
			"r": "3",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 5.51,
			"r": "38",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 4.96,
			"r": "51",
			"m": 96,
			"y": "2014"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.37,
			"r": "84",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 4.4,
			"r": "81",
			"m": 103,
			"y": "2013"
		},
		"ATA": null,
		"SVN": {
			"v": 6.21,
			"r": "11",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 3.84,
			"r": "101",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 2.71,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.01,
			"r": "129",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 4.76,
			"r": "63",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.36,
			"r": "118",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.03,
			"r": "21",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 2.97,
			"r": "130",
			"m": 94,
			"y": "2014"
		},
		"TJK": {
			"v": 3.44,
			"r": "114",
			"m": 104,
			"y": "2014"
		},
		"AUS": {
			"v": 6.15,
			"r": "15",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.21,
			"r": "43",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 4.78,
			"r": "59",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 5.03,
			"r": "49",
			"m": 104,
			"y": "2013"
		},
		"CIV": {
			"v": 3.11,
			"r": "126",
			"m": 92,
			"y": "2014"
		},
		"ABW": null,
		"ESP": {
			"v": 6.08,
			"r": "18",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.87,
			"r": "53",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 3.92,
			"r": "97",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 6.06,
			"r": "19",
			"m": 95,
			"y": "2014"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.72,
			"r": "66",
			"m": 97,
			"y": "2014"
		},
		"BWA": {
			"v": 4.45,
			"r": "78",
			"m": 91,
			"y": "2014"
		},
		"MDA": {
			"v": 4.64,
			"r": "72",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 4.56,
			"r": "75",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 5.43,
			"r": "40",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 3.08,
			"r": "128",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.23,
			"r": "138",
			"m": 95,
			"y": "2013"
		},
		"CAF": null,
		"LKA": {
			"v": 4.43,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 3.67,
			"r": "107",
			"m": 88,
			"y": "2014"
		},
		"NFK": null,
		"HKG": {
			"v": 6.57,
			"r": "2",
			"m": 96,
			"y": "2014"
		},
		"COD": null,
		"ZAF": {
			"v": 3.66,
			"r": "108",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 4.77,
			"r": "61",
			"m": 105,
			"y": "2014"
		},
		"CYP": {
			"v": 5.77,
			"r": "29",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 5.69,
			"r": "33",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 2.28,
			"r": "137",
			"m": 104,
			"y": "2014"
		},
		"HTI": {
			"v": 2.21,
			"r": "138",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 5.83,
			"r": "27",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 4.77,
			"r": "62",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.01,
			"r": "22",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 4.41,
			"r": "80",
			"m": 96,
			"y": "2014"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.8,
			"r": "103",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 5.09,
			"r": "48",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 4.83,
			"r": "57",
			"m": 48,
			"y": "2014"
		},
		"MLI": {
			"v": 3.33,
			"r": "119",
			"m": 100,
			"y": "2014"
		},
		"OMN": {
			"v": 4.68,
			"r": "70",
			"m": 103,
			"y": "2014"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.61,
			"r": "73",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 4.45,
			"r": "77",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 6.18,
			"r": "13",
			"m": 103,
			"y": "2014"
		},
		"BGD": {
			"v": 3.37,
			"r": "116",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 6.01,
			"r": "23",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 6.11,
			"r": "17",
			"m": 103,
			"y": "2014"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.82,
			"r": "28",
			"m": 100,
			"y": "2014"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.7,
			"r": "105",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.94,
			"r": "131",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 5.04,
			"r": "50",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 3.98,
			"r": "95",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.22,
			"r": "90",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 2.83,
			"r": "133",
			"m": 100,
			"y": "2014"
		},
		"DMA": null,
		"BFA": {
			"v": 4.02,
			"r": "93",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.03,
			"r": "91",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 4.85,
			"r": "56",
			"m": 104,
			"y": "2014"
		},
		"SRB": {
			"v": 5.18,
			"r": "44",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 3.53,
			"r": "111",
			"m": 95,
			"y": "2014"
		},
		"RUS": {
			"v": 4.04,
			"r": "93",
			"m": 103,
			"y": "2013"
		},
		"EST": {
			"v": 5.74,
			"r": "31",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 4.78,
			"r": "60",
			"m": 91,
			"y": "2014"
		},
		"NIU": null,
		"USA": {
			"v": 5.62,
			"r": "35",
			"m": 105,
			"y": "2014"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.89,
			"r": "52",
			"m": 104,
			"y": "2014"
		},
		"JPN": {
			"v": 6.77,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 4.03,
			"r": "92",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.14,
			"r": "16",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 4.66,
			"r": "71",
			"m": 105,
			"y": "2014"
		},
		"SGP": {
			"v": 6.41,
			"r": "6",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 3.51,
			"r": "111",
			"m": 83,
			"y": "2013"
		},
		"COL": {
			"v": 4.71,
			"r": "67",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 6.35,
			"r": "8",
			"m": 96,
			"y": "2014"
		},
		"LAO": {
			"v": 4.51,
			"r": "76",
			"m": 98,
			"y": "2014"
		},
		"FLK": null,
		"LUX": {
			"v": 6.22,
			"r": "10",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 4.87,
			"r": "54",
			"m": 101,
			"y": "2014"
		},
		"SLE": {
			"v": 2.15,
			"r": "141",
			"m": 104,
			"y": "2014"
		},
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": {
			"v": 2.82,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 3.08,
			"r": "127",
			"m": 105,
			"y": "2014"
		},
		"KWT": {
			"v": 2.6,
			"r": "136",
			"m": 97,
			"y": "2014"
		},
		"ESH": null,
		"SEN": {
			"v": 3.81,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"CMR": {
			"v": 3.29,
			"r": "122",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 3.22,
			"r": "123",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 2.18,
			"r": "139",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.32,
			"r": "120",
			"m": 104,
			"y": "2014"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.36,
			"r": "117",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 5.75,
			"r": "30",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 6.25,
			"r": "9",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 6.38,
			"r": "7",
			"m": 104,
			"y": "2014"
		},
		"BRB": {
			"v": 6.06,
			"r": "20",
			"m": 89,
			"y": "2014"
		},
		"MHL": null,
		"AND": null
	},
	"EXPCOSTCOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SHAREDUTYFREE": {
		"UNK": null,
		"NOR": {
			"v": 95.23,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 95.13,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 26.66,
			"r": "114",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 94.04,
			"r": "15",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 68.63,
			"r": "68",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 42.27,
			"r": "99",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 12.02,
			"r": "123",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 59.77,
			"r": "83",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 90.51,
			"r": "29",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 66.66,
			"r": "71",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 31.49,
			"r": "110",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 53.73,
			"r": "92",
			"m": 96,
			"y": "2011"
		},
		"SLB": null,
		"URY": {
			"v": 56.86,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 84.16,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 83.01,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 89.83,
			"r": "31",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 56.25,
			"r": "90",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 51.24,
			"r": "94",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 78.98,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 89.04,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 86.88,
			"r": "43",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 44.51,
			"r": "97",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 65.73,
			"r": "73",
			"m": 103,
			"y": "2013"
		},
		"COK": null,
		"KEN": {
			"v": 46.03,
			"r": "96",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 86.82,
			"r": "44",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 92.51,
			"r": "22",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 82.25,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 91.66,
			"r": "25",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 94.77,
			"r": "9",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 91.54,
			"r": "26",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 92.52,
			"r": "21",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 93.24,
			"r": "18",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 30.68,
			"r": "112",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 5.11,
			"r": "130",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 94.08,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 91.76,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 5.87,
			"r": "129",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 61.28,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.02,
			"r": "135",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 87.06,
			"r": "42",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "136",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 66.5,
			"r": "72",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 59.24,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 93.06,
			"r": "19",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 11.24,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 75.3,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 26.23,
			"r": "115",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 94.21,
			"r": "13",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 31.31,
			"r": "111",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 80.57,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 78.26,
			"r": "57",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 63.63,
			"r": "75",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 92.87,
			"r": "20",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 57.41,
			"r": "87",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 63.47,
			"r": "76",
			"m": 104,
			"y": "2008"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 39.52,
			"r": "103",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 88.03,
			"r": "39",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 22.1,
			"r": "117",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 22.9,
			"r": "116",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 57.87,
			"r": "85",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 70.69,
			"r": "66",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 92.19,
			"r": "23",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 10.85,
			"r": "125",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 88.21,
			"r": "38",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 67.37,
			"r": "69",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 42.32,
			"r": "98",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 84.19,
			"r": "45",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 40.11,
			"r": "101",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 96.67,
			"r": "3",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 55.75,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 62.1,
			"r": "78",
			"m": 96,
			"y": "2013"
		},
		"DNK": {
			"v": 88.88,
			"r": "36",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 72.66,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 63.3,
			"r": "77",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 51.45,
			"r": "93",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 100,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0.34,
			"r": "133",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 73.99,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 70.94,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 90.82,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 94.63,
			"r": "11",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 16.2,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 89.33,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 91.13,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 87.82,
			"r": "40",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 21.35,
			"r": "118",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 33.76,
			"r": "108",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 90.33,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 89.47,
			"r": "32",
			"m": 54,
			"y": "2015"
		},
		"MLI": {
			"v": 34.5,
			"r": "106",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 60.16,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 87.74,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 83.23,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 16.18,
			"r": "120",
			"m": 86,
			"y": "2007"
		},
		"AUT": {
			"v": 95.43,
			"r": "4",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 34.15,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 94.5,
			"r": "12",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 42.23,
			"r": "100",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 57.15,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 27.26,
			"r": "113",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 95.22,
			"r": "6",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 80.45,
			"r": "52",
			"m": 105,
			"y": "2013"
		},
		"MRT": {
			"v": 8.69,
			"r": "128",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 13.41,
			"r": "122",
			"m": 96,
			"y": "2009"
		},
		"TUN": {
			"v": 80.4,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 80.17,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 15.89,
			"r": "121",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 39.71,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 93.61,
			"r": "17",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 50.19,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 77.3,
			"r": "58",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 70.58,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 79.05,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 74.03,
			"r": "62",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 88.37,
			"r": "37",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 60.37,
			"r": "80",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 99.97,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 10.35,
			"r": "126",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 60.35,
			"r": "81",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 94.95,
			"r": "8",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 75.97,
			"r": "59",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 93.82,
			"r": "16",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 94.73,
			"r": "10",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0.31,
			"r": "134",
			"m": 104,
			"y": "2006"
		},
		"ARE": {
			"v": 35.97,
			"r": "105",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 83.17,
			"r": "48",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 64.35,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 39.36,
			"r": "104",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 8.96,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 4.9,
			"r": "131",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 2.13,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 57.6,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 31.75,
			"r": "109",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 88.93,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 75.6,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 66.76,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"fees_charges": {
		"UNK": null,
		"NOR": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.67,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.75,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.75,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.75,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.5,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.25,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.75,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.67,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.25,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.33,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.67,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.75,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.67,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.67,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 0.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.5,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.5,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ469": {
		"UNK": null,
		"NOR": {
			"v": 5,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.16,
			"r": "112",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 4.07,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.78,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.2,
			"r": "109",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "21",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.79,
			"r": "70",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.57,
			"r": "85",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.71,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.23,
			"r": "43",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.04,
			"r": "52",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.5,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.27,
			"r": "41",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.5,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.84,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.89,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.55,
			"r": "87",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.92,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.34,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.94,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.16,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.62,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.26,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.45,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.28,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.77,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.99,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.36,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.94,
			"r": "121",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.82,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.04,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.64,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.26,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.53,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.92,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.46,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "84",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.99,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.63,
			"r": "78",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.22,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.2,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.07,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.76,
			"r": "72",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.81,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.55,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.28,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.22,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.68,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.58,
			"r": "131",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.13,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.67,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.7,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.55,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.75,
			"r": "69",
			"m": 96,
			"y": "2015"
		},
		"SUR": null,
		"DOM": {
			"v": 3.57,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.86,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.45,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.12,
			"r": "11",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.7,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.01,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.3,
			"r": "39",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.6,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.92,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.54,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.98,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.67,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.81,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.17,
			"r": "10",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.65,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.59,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.83,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.36,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.42,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.98,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.86,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.52,
			"r": "29",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.74,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.75,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.65,
			"r": "27",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.93,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.49,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.38,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.43,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.12,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 3.59,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.99,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.03,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.8,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.45,
			"r": "95",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.52,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.5,
			"r": "92",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.99,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.47,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.39,
			"r": "90",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.21,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.78,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.16,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.35,
			"r": "7",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.21,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.2,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.84,
			"r": "66",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.03,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.59,
			"r": "82",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.04,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.32,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.31,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.33,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.89,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.19,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.24,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.86,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.16,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.95,
			"r": "14",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.4,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.46,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.43,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.91,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.04,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.71,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.07,
			"r": "114",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.48,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.36,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.09,
			"r": "49",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.25,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.81,
			"r": "68",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.68,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 4.75,
			"r": "24",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.05,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.82,
			"r": "121",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.21,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.1,
			"r": "48",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.18,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.24,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.21,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.02,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.94,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.74,
			"r": "25",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.9,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.64,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.64,
			"r": "77",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"form_docs": {
		"UNK": null,
		"NOR": {
			"v": 1.14,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.17,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 0.86,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.5,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 0.86,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.71,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 0.67,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.83,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.83,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.33,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.17,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.83,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 0.86,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.33,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.67,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.14,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.4,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.67,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.4,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.17,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.86,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.17,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.83,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.2,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.43,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.43,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.8,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.33,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.5,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.5,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.17,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.83,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 0.83,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.4,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 0.71,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.83,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 0.86,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.67,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.17,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.86,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.29,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.83,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.83,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.17,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.43,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 0.83,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.17,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.71,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.83,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.67,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.4,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.83,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.83,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.17,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.4,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.83,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.29,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.14,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 240,
			"r": "127",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 154.3,
			"r": "116",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 54,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 203.31,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 24,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6,
			"r": "39",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 30.14,
			"r": "56",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 80,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 13,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 1.56,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 72,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 72,
			"r": "82",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 41.04,
			"r": "62",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 14,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 7.5,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 64,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 7.5,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 180,
			"r": "118",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.5,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 44.22,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 39.67,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.38,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 48,
			"r": "66",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 54,
			"r": "72",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 60,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 276,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 283.71,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 60.78,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 154.25,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 217,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 23.22,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 141,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 63.69,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 48,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 240,
			"r": "127",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.5,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 129.29,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 50.18,
			"r": "69",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 37,
			"r": "58",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 79,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 63.13,
			"r": "78",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 75.14,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 80,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 85.67,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 84,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 48,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 24,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 78,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 111,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 24,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 84,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 107.83,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 39,
			"r": "59",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 106,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 97,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 125.14,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 60,
			"r": "75",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 3,
			"r": "31",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.42,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.39,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 99.36,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 96,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 91,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 72,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 114,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 18.55,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 588,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 144,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 61.97,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 14.67,
			"r": "46",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 242,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 83,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 87,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 327.39,
			"r": "133",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.5,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "42",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 98.33,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 70.29,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 5,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 1,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 183,
			"r": "121",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 88,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 51,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 96,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 180,
			"r": "118",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 48,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 228,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 15,
			"r": "47",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 163,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 84,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 102,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 283.35,
			"r": "131",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 80,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 89.43,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 96,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 92.31,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "25",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 41.08,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 39.6,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 72,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 35.43,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 82,
			"r": "94",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 112,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 13.5,
			"r": "44",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.5,
			"r": "37",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 181.71,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 54,
			"r": "72",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.95,
			"r": "38",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 232,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 227.67,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 214.91,
			"r": "123",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 53.33,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 271,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 48,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 100,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 402,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 98.73,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 25,
			"r": "55",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 47.38,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 104,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0402": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TERRORISMINCIDENCE": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 6.98,
			"r": "51",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 6.94,
			"r": "68",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 6.91,
			"r": "74",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 4.8,
			"r": "113",
			"m": 81,
			"y": "2014"
		},
		"BHR": {
			"v": 5.77,
			"r": "109",
			"m": 86,
			"y": "2014"
		},
		"ETH": {
			"v": 6.52,
			"r": "95",
			"m": 94,
			"y": "2014"
		},
		"ECU": {
			"v": 6.97,
			"r": "54",
			"m": 94,
			"y": "2014"
		},
		"FRA": {
			"v": 5.49,
			"r": "110",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 6.99,
			"r": "38",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 6.97,
			"r": "54",
			"m": 81,
			"y": "2014"
		},
		"JAM": {
			"v": 6.99,
			"r": "38",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 6.98,
			"r": "42",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 6.93,
			"r": "71",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 6.73,
			"r": "90",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.97,
			"r": "57",
			"m": 78,
			"y": "2014"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.99,
			"r": "106",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.89,
			"r": "77",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 6.92,
			"r": "73",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 2.95,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"KHM": {
			"v": 6.98,
			"r": "42",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"r": "126",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 1.92,
			"r": "123",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 6.98,
			"r": "49",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 6.21,
			"r": "104",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 7,
			"r": "1",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 6.74,
			"r": "89",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 1,
			"r": "126",
			"m": 105,
			"y": "2014"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 7,
			"y": "2014",
			"m": 16
		},
		"NGA": {
			"v": 1,
			"r": "126",
			"m": 102,
			"y": "2014"
		},
		"PRT": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 6.93,
			"r": "72",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 5.44,
			"r": "111",
			"m": 103,
			"y": "2014"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.52,
			"r": "96",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 6.99,
			"r": "33",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 6.98,
			"r": "52",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 6.39,
			"r": "98",
			"m": 96,
			"y": "2014"
		},
		"SPM": null,
		"MWI": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 6.99,
			"y": "2014",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"r": "126",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 6.95,
			"r": "65",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 1,
			"r": "126",
			"m": 103,
			"y": "2014"
		},
		"IMN": null,
		"THA": {
			"v": 1,
			"r": "126",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 6.96,
			"r": "63",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 1,
			"y": "2014",
			"m": 100
		},
		"CHE": {
			"v": 6.98,
			"r": "42",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 6.89,
			"r": "76",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 6.86,
			"r": "85",
			"m": 96,
			"y": "2014"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 6.7,
			"r": "91",
			"m": 103,
			"y": "2014"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 7,
			"y": "2014",
			"m": 96
		},
		"SUR": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"DOM": {
			"v": 6.88,
			"r": "80",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 6.97,
			"r": "59",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 6.99,
			"y": "2014",
			"m": 105
		},
		"PAN": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.96,
			"r": "61",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 7,
			"r": "1",
			"m": 94,
			"y": "2014"
		},
		"TJK": {
			"v": 6.89,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"AUS": {
			"v": 6.83,
			"r": "86",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.99,
			"r": "33",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "42",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"CIV": {
			"v": 6.82,
			"r": "88",
			"m": 92,
			"y": "2014"
		},
		"ABW": null,
		"ESP": {
			"v": 6.93,
			"r": "70",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.99,
			"r": "33",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 6.97,
			"r": "57",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 3.9,
			"r": "117",
			"m": 95,
			"y": "2014"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.97,
			"r": "60",
			"m": 97,
			"y": "2014"
		},
		"BWA": {
			"v": 7,
			"r": "1",
			"m": 91,
			"y": "2014"
		},
		"MDA": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 5.89,
			"r": "107",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 6.94,
			"r": "67",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 6.96,
			"r": "64",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 6.95,
			"y": "2014",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 6.33,
			"r": "99",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 7,
			"r": "1",
			"m": 88,
			"y": "2014"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 1.84,
			"r": "124",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 6.55,
			"r": "94",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"CYP": {
			"v": 6.87,
			"r": "83",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 4.56,
			"r": "115",
			"m": 104,
			"y": "2014"
		},
		"HTI": {
			"v": 7,
			"y": "2014",
			"m": 96
		},
		"IRL": {
			"v": 6.3,
			"r": "101",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.65,
			"r": "92",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.83,
			"r": "108",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 6.08,
			"r": "105",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 6.94,
			"r": "68",
			"m": 48,
			"y": "2014"
		},
		"MLI": {
			"v": 2.05,
			"r": "122",
			"m": 100,
			"y": "2014"
		},
		"OMN": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"BLR": {
			"v": 7,
			"y": "2014",
			"m": 86
		},
		"ITA": {
			"v": 6.83,
			"r": "87",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 6.98,
			"r": "52",
			"m": 103,
			"y": "2014"
		},
		"BGD": {
			"v": 1,
			"r": "126",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 6.99,
			"r": "41",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 6.99,
			"r": "38",
			"m": 103,
			"y": "2014"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ATG": null,
		"AFG": {
			"v": 1,
			"y": "2014",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 1.07,
			"r": "125",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.51,
			"r": "97",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "116",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 6.95,
			"r": "66",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"DMA": null,
		"BFA": {
			"v": 6.9,
			"y": "2014",
			"m": 85
		},
		"IND": {
			"v": 1,
			"r": "126",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 5.3,
			"r": "112",
			"m": 104,
			"y": "2014"
		},
		"SRB": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 6.98,
			"r": "49",
			"m": 95,
			"y": "2014"
		},
		"RUS": {
			"v": 3.4,
			"r": "119",
			"m": 103,
			"y": "2014"
		},
		"EST": {
			"v": 6.98,
			"r": "42",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 3.48,
			"r": "118",
			"m": 91,
			"y": "2014"
		},
		"NIU": null,
		"USA": {
			"v": 4.65,
			"r": "114",
			"m": 105,
			"y": "2014"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1,
			"r": "126",
			"m": 104,
			"y": "2014"
		},
		"JPN": {
			"v": 6.88,
			"r": "78",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 6.63,
			"r": "93",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.33,
			"r": "100",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"r": "126",
			"m": 105,
			"y": "2014"
		},
		"SGP": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 7,
			"r": "1",
			"m": 83,
			"y": "2014"
		},
		"COL": {
			"v": 1,
			"r": "126",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 6.99,
			"r": "33",
			"m": 96,
			"y": "2014"
		},
		"LAO": {
			"v": 6.98,
			"r": "42",
			"m": 98,
			"y": "2014"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 7,
			"r": "1",
			"m": 101,
			"y": "2014"
		},
		"SLE": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"ARE": {
			"v": 6.97,
			"r": "54",
			"m": 71,
			"y": "2014"
		},
		"GNB": null,
		"BIH": {
			"v": 6.88,
			"r": "81",
			"m": 86,
			"y": "2014"
		},
		"MMR": {
			"v": 5.64,
			"y": "2014",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 6.96,
			"r": "62",
			"m": 105,
			"y": "2014"
		},
		"KWT": {
			"v": 6.23,
			"r": "103",
			"m": 97,
			"y": "2014"
		},
		"ESH": null,
		"SEN": {
			"v": 6.88,
			"r": "82",
			"m": 104,
			"y": "2014"
		},
		"CMR": {
			"v": 2.79,
			"r": "121",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"TZA": {
			"v": 6.26,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.88,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 6.86,
			"r": "84",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 6.99,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 6.98,
			"r": "42",
			"m": 104,
			"y": "2014"
		},
		"BRB": {
			"v": 7,
			"y": "2014",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ034": {
		"UNK": null,
		"NOR": {
			"v": 5.82,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.58,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.62,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.27,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.33,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.37,
			"r": "31",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.09,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "109",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.8,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.91,
			"r": "55",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.55,
			"r": "20",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 2.32,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.74,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.42,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.38,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.85,
			"r": "60",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.42,
			"r": "27",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.29,
			"r": "122",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.34,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.07,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.42,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.96,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.25,
			"r": "84",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.72,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.76,
			"r": "128",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.37,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.65,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 1.8,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.13,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.26,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.03,
			"r": "50",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.22,
			"r": "86",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.32,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.65,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.05,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.57,
			"r": "114",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.09,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.9,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.37,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.07,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.63,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.08,
			"r": "92",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.38,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.26,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.82,
			"r": "132",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.92,
			"r": "124",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4,
			"r": "97",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.86,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.97,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.98,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.47,
			"r": "138",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.71,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.66,
			"r": "129",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.86,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.22,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.33,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.75,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.63,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 4.31,
			"r": "78",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.08,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.45,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.42,
			"r": "71",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.52,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 6.62,
			"r": "1",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.09,
			"r": "48",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.56,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.88,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.13,
			"r": "45",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.4,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.67,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.16,
			"r": "88",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.78,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.42,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.66,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.49,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.12,
			"r": "47",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.21,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.3,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.85,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.94,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.41,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.39,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.61,
			"r": "112",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.99,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.59,
			"r": "72",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.08,
			"r": "9",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 4.19,
			"r": "89",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.44,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.67,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.32,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.82,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.96,
			"r": "126",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.2,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.03,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.81,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.27,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.6,
			"r": "71",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.99,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.77,
			"r": "66",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.6,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.28,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.67,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.99,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.21,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.58,
			"r": "114",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.51,
			"r": "22",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.37,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.19,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.89,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.75,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.74,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.5,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.7,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.42,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.81,
			"r": "103",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.36,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.06,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.37,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.2,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.5,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.53,
			"r": "21",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.9,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.61,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.45,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.32,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.81,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.8,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.48,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.15,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.31,
			"r": "82",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.8,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.15,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.89,
			"r": "57",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.78,
			"r": "13",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.16,
			"r": "90",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.81,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.43,
			"r": "1",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.04,
			"r": "96",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.36,
			"r": "120",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 4.79,
			"r": "65",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.34,
			"r": "32",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.66,
			"r": "69",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.89,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 5.15,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.84,
			"r": "99",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.21,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.64,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.3,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.4,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.94,
			"r": "101",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ048": {
		"UNK": null,
		"NOR": {
			"v": 4.17,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.02,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.39,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 2.8,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.02,
			"r": "102",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.65,
			"r": "10",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.6,
			"r": "55",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 2.22,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 2.76,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 2.99,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.31,
			"r": "17",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.14,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.09,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.46,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.43,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "6",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.74,
			"r": "42",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.43,
			"r": "138",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.19,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.78,
			"r": "114",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.68,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.69,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.5,
			"r": "65",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.89,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.23,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.71,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.69,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.18,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.68,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.31,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 3.48,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.3,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.07,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.62,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.66,
			"r": "128",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.97,
			"r": "107",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 2.83,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.51,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.1,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.74,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.91,
			"r": "34",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.55,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.12,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.4,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.9,
			"r": "101",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.51,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.49,
			"r": "66",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.4,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.51,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.51,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.45,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.82,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.68,
			"r": "137",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.74,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.57,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.47,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 2.74,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.39,
			"r": "73",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.22,
			"r": "93",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.82,
			"r": "110",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.25,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.31,
			"r": "50",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 3.75,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.48,
			"r": "129",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 3.24,
			"r": "89",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.37,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.48,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.39,
			"r": "77",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.56,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.64,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "16",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.04,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 2.8,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.68,
			"r": "48",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.23,
			"r": "132",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.05,
			"r": "25",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.83,
			"r": "38",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.49,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.8,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.88,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 3.3,
			"r": "84",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.68,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.5,
			"r": "62",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.58,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.53,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.23,
			"r": "4",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.62,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.98,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.24,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.97,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 2.33,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.16,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.09,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.65,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 2.7,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.09,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.35,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.25,
			"r": "86",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.4,
			"r": "129",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.65,
			"r": "11",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.42,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 3.71,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.46,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 1.96,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 3.98,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.16,
			"r": "93",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.67,
			"r": "50",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.05,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.8,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.04,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.45,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.04,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.81,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.68,
			"r": "47",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.18,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.6,
			"r": "56",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.09,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.99,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.44,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.51,
			"r": "62",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.01,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.09,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.15,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.04,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.45,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.61,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.21,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.28,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.41,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.59,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.34,
			"r": "81",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.62,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.32,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.91,
			"r": "35",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.53,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.98,
			"r": "32",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.35,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.33,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.58,
			"r": "125",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.94,
			"r": "111",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.35,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.89,
			"r": "108",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.66,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.38,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.1,
			"r": "100",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.52,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.16,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 3.77,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.05,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.99,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.51,
			"r": "64",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ055": {
		"UNK": null,
		"NOR": {
			"v": 6.48,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.87,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.93,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.2,
			"r": "133",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.66,
			"r": "32",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.88,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.76,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.3,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.27,
			"r": "74",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.79,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.24,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.99,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.73,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.39,
			"r": "37",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.41,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.81,
			"r": "43",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.75,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.7,
			"r": "98",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.98,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.08,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.02,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.45,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.86,
			"r": "92",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.7,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.51,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.27,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.72,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.19,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.69,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.91,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.18,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.22,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.27,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.81,
			"r": "129",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.99,
			"r": "118",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.71,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.79,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.8,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.99,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.58,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.72,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.3,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.95,
			"r": "124",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.33,
			"r": "111",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 3.53,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.11,
			"r": "115",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.61,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.23,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.56,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.42,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.99,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.47,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.44,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.49,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 2.79,
			"r": "131",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 4.45,
			"r": "54",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.36,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.76,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.47,
			"r": "55",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.69,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.61,
			"r": "97",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.88,
			"r": "25",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.94,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.82,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.26,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.8,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.33,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.12,
			"r": "2",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.05,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.19,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.55,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.97,
			"r": "119",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.06,
			"r": "20",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.08,
			"r": "84",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.84,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.21,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.97,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.5,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.04,
			"r": "5",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.21,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.48,
			"r": "129",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.21,
			"r": "6",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 3.67,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.32,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.16,
			"r": "81",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.45,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.58,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.87,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.01,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 6.11,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.09,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.72,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.93,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.65,
			"r": "59",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.73,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.03,
			"r": "44",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.58,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.26,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.57,
			"r": "50",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 4.32,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.23,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.09,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.18,
			"r": "16",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.27,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.75,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.51,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.78,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.84,
			"r": "26",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.31,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.4,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.13,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.05,
			"r": "77",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.74,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.3,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.73,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.69,
			"r": "57",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.5,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.07,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.69,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.97,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.35,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.13,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.56,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.34,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.55,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.08,
			"r": "85",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.39,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.41,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.43,
			"r": "65",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "13",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.44,
			"r": "64",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.51,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.42,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.95,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.86,
			"r": "126",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 3.5,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.07,
			"r": "43",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.07,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.34,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.15,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.58,
			"r": "104",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.27,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.91,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.27,
			"r": "10",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.61,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.46,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.5,
			"r": "34",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ147": {
		"UNK": null,
		"NOR": {
			"v": 6.21,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.26,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.8,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.21,
			"r": "93",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.53,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.08,
			"r": "100",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "66",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.08,
			"r": "34",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.51,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.33,
			"r": "85",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.17,
			"r": "95",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.11,
			"r": "33",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.66,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.13,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "43",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.58,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.89,
			"r": "39",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.53,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.88,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.08,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.54,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.43,
			"r": "127",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.68,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.26,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.44,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.99,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.73,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.73,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.62,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.77,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.94,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.95,
			"r": "139",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 1.9,
			"r": "134",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.21,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.65,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.33,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.69,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.61,
			"r": "74",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.82,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.3,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.07,
			"r": "139",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.31,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.34,
			"r": "83",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.99,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.25,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.54,
			"r": "125",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.37,
			"r": "130",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.24,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.09,
			"r": "99",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.62,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.66,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.84,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.48,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 2.78,
			"r": "112",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.85,
			"r": "108",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.75,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.84,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.99,
			"r": "87",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.01,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.51,
			"r": "122",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.78,
			"r": "22",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "92",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.08,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.99,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.75,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.75,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.51,
			"r": "77",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.44,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.75,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.39,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.42,
			"r": "128",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.94,
			"r": "18",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.31,
			"r": "54",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.42,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.13,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.2,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.79,
			"r": "140",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 2.93,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.65,
			"r": "121",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.17,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.7,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.11,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 2.8,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.49,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.34,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.8,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "131",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.4,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.82,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.29,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.65,
			"r": "119",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.03,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.17,
			"r": "58",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 2.58,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.9,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.5,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.36,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.08,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 1.96,
			"r": "133",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.88,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.19,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.18,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.65,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.66,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.19,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.12,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.9,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.73,
			"r": "113",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.31,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.58,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 2.76,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.68,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.05,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.29,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.86,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.19,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.35,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "30",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.65,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.61,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.27,
			"r": "130",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.58,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.59,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.13,
			"r": "97",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "64",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 1.97,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.31,
			"r": "6",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.3,
			"r": "90",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.29,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.83,
			"r": "107",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.46,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.31,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.76,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.34,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.37,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 2.86,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.58,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.87,
			"r": "67",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-CLEAREFF": {
		"UNK": null,
		"NOR": {
			"v": 4.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 2.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 4.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 2.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 3.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 3.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 2.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 2.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 3.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 5.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 3.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 2.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 3.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 2.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 2.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 4.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 1.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"OPENMULTRDRULE": {
		"UNK": null,
		"NOR": {
			"v": 81.4,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 89.4,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 50.8,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 82.8,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 50.9,
			"r": "117",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 74.5,
			"r": "45",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 34.2,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 65.4,
			"r": "74",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 82.8,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 77.5,
			"r": "35",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 80.4,
			"r": "27",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 54.8,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 66.8,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 68.1,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 64.5,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 59.8,
			"r": "93",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 77.5,
			"r": "35",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 49.9,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 59.1,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 84.5,
			"r": "11",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 60.3,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 56.4,
			"r": "104",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 65.1,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 64.8,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 57.8,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 77.5,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 66.4,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 80.5,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 87.5,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 45.2,
			"r": "127",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 74.7,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 69.4,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 34.7,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 70.6,
			"r": "56",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 77.6,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 77.8,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 44.1,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 56.6,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 63.3,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 82.8,
			"r": "14",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 48.4,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 45.4,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 73.8,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 82,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 55.6,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 52.9,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 61,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 80,
			"r": "28",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 60,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 61.6,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 67.9,
			"r": "67",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 71.8,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 92.2,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 65.2,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 62.2,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 67.7,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 86.3,
			"r": "7",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 62.3,
			"r": "84",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 54,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 80.5,
			"r": "23",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 72.5,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 89.4,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 57.2,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 83.8,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 33.6,
			"r": "134",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 73.3,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 73.9,
			"r": "49",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 70.6,
			"r": "56",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 55.4,
			"r": "106",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 74.8,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 47.4,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 85.2,
			"r": "8",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 70,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 59,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 45.9,
			"r": "124",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 47,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 59.7,
			"r": "94",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 55.2,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 80.5,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 87.5,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 36.9,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 74.3,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 77.3,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 80.5,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 51.3,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 65.5,
			"r": "73",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 85.2,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 74,
			"r": "48",
			"m": 63,
			"y": "2016"
		},
		"MLI": {
			"v": 61.8,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 75.5,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 81.8,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 80,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 56.5,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 82,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 62.4,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 69.1,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 60.7,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 79.7,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 58.8,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 72.3,
			"r": "53",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 64.6,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 49.9,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 63.8,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 61.8,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 89.6,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 65.7,
			"r": "72",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 71.8,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 82.2,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 83.9,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 81.3,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 77.4,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 69.2,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 69.7,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 84.7,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 78.8,
			"r": "32",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 62.5,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 54.8,
			"r": "109",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 68.1,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 66.9,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 42,
			"r": "130",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 80,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 42.2,
			"r": "129",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 45.9,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 57.1,
			"r": "100",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 74.6,
			"r": "44",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 55.4,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 53.3,
			"r": "112",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 57,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 52,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 68.1,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 53.2,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 75.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 69.1,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 74.3,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"MARGINPREF": {
		"UNK": null,
		"NOR": {
			"v": 29.61,
			"r": "96",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 56.88,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 10.24,
			"r": "123",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 53.34,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 41.03,
			"r": "75",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 41.84,
			"r": "72",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 25.64,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 43.71,
			"r": "64",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 45.82,
			"r": "60",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 13.03,
			"r": "118",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 32.11,
			"r": "93",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 63.31,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 40.79,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 41.79,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 56.4,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 23.02,
			"r": "109",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 62.27,
			"r": "16",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 61.69,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 64.01,
			"r": "11",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 62.65,
			"r": "14",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 31.46,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 63.21,
			"r": "13",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 35.8,
			"r": "83",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 68.28,
			"r": "9",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 84.44,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 48.71,
			"r": "52",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 77.09,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 42.82,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 51.12,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 48.7,
			"r": "53",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 45.37,
			"r": "61",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 40.42,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 43.15,
			"r": "66",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 7.3,
			"r": "128",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 48.47,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 33.26,
			"r": "90",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 89.89,
			"r": "2",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 72.29,
			"r": "5",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 40.94,
			"r": "77",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 56.51,
			"r": "26",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "136",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 65.71,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 48.99,
			"r": "51",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 43.24,
			"r": "65",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 24.77,
			"r": "103",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 33.48,
			"r": "89",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 49.06,
			"r": "50",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 24.39,
			"r": "106",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 18.38,
			"r": "112",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 62.28,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 32.54,
			"r": "91",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 34.28,
			"r": "85",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 53.49,
			"r": "37",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 41,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 42.06,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 22.48,
			"r": "110",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 51.24,
			"r": "44",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 5.83,
			"r": "132",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 12.53,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 5.75,
			"r": "133",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 54.66,
			"r": "33",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 50.74,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 42.2,
			"r": "69",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 57.09,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 69.93,
			"r": "7",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 50.3,
			"r": "48",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 32.35,
			"r": "92",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 28.24,
			"r": "98",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 28.53,
			"r": "97",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 52.71,
			"r": "40",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 24.62,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 47.12,
			"r": "56",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 71.27,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 14.78,
			"r": "116",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 54.61,
			"r": "34",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 7.71,
			"r": "127",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 13.45,
			"r": "117",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 34.08,
			"r": "86",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 31.67,
			"r": "94",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 37.93,
			"r": "82",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 51.04,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 12.31,
			"r": "121",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 46.67,
			"r": "57",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 55.8,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 39.52,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 58.51,
			"r": "21",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 33.97,
			"r": "87",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 54.96,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 58.19,
			"r": "22",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 25.78,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 21.87,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 41.63,
			"r": "74",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 54.01,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 61.17,
			"r": "18",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 47.71,
			"r": "55",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.49,
			"r": "134",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 93.11,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 49.1,
			"r": "49",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 28.09,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 16.03,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 57.79,
			"r": "23",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 42.89,
			"r": "67",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 24.42,
			"r": "105",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 8.75,
			"r": "124",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 52.8,
			"r": "39",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 51.3,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 34.74,
			"r": "84",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 12.37,
			"r": "120",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 44.68,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 6.75,
			"r": "129",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 23.45,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 40.9,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 6.67,
			"r": "130",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 54.75,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 41.98,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 24.13,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 33.97,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 16.46,
			"r": "114",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 45.99,
			"r": "59",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 52.41,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 52.06,
			"r": "42",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 53.98,
			"r": "36",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 45.21,
			"r": "62",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 10.6,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 8.16,
			"r": "125",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 59.92,
			"r": "19",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 55.7,
			"r": "30",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 6.13,
			"r": "131",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 56.1,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 46.48,
			"r": "58",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 1.59,
			"r": "135",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 58.64,
			"r": "20",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 69.53,
			"r": "8",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 25.67,
			"r": "101",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 18.26,
			"r": "113",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 7.81,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"gov_impartiality": {
		"UNK": null,
		"NOR": {
			"v": 1.44,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.8,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.33,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.43,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.86,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.57,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0.83,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.29,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.43,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.57,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.86,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.38,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.62,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.88,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.17,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.62,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.83,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.75,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.75,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.57,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.75,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.62,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.17,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.14,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.17,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.88,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.22,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.2,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.71,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.44,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.89,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.89,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.17,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.71,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.88,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.62,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.89,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.78,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 0.8,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.43,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.4,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.89,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.14,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.89,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 0.62,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.14,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.43,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.12,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.5,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.89,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.89,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.8,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.29,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.5,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.25,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.67,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 528,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 120,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 24,
			"r": "68",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 91,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 24,
			"r": "68",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "18",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 33,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 47,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 24,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 48,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 10,
			"r": "58",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"r": "28",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 70.33,
			"r": "106",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 48,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 2,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 12.5,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 132,
			"r": "124",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 72,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 19,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 8,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 9.33,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 2.5,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 163,
			"r": "129",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 24,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 2,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 48,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 169,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 131.43,
			"r": "123",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 1,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 18.64,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 63.75,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 186,
			"r": "131",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.41,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 152,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 83,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 38,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 88,
			"r": "111",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 1.75,
			"r": "27",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 59,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 11.27,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 21,
			"r": "65",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 72,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1.56,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 18,
			"r": "62",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 24,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 42,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 200,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 12,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 10,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 32,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 174,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 6,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.5,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 60,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 66,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 7,
			"r": "52",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 25.62,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.75,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 44,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 120,
			"r": "119",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9,
			"r": "54",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 30,
			"r": "78",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4,
			"r": "45",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 128,
			"r": "121",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 24,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 48,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 61.32,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 48,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 139,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 76,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 192,
			"r": "132",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 0.67,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 697.85,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 68,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 50,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 87,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 22,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 1,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 61.33,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 149.14,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 1,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "49",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 48,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 22,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 4,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 147,
			"r": "126",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.5,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 9.78,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 9,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 228,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 48,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 24,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 90,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2,
			"r": "28",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 130,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 50.67,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 84,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 38.39,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.33,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 89.33,
			"r": "112",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 25.4,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 21.2,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "25",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 2.37,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 48,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 1,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 96,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 2,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 48,
			"r": "86",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 60,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 2,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 216,
			"r": "133",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 90,
			"r": "113",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 133.71,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.22,
			"r": "51",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.33,
			"r": "46",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 144,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 99,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 32.4,
			"r": "81",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 26,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 66,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 168,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 33,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 96,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 48.91,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 1,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 31.38,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 54,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETI_INSTITQUALITY": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ052": {
		"UNK": null,
		"NOR": {
			"v": 5.99,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.78,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.99,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.89,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.65,
			"r": "136",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.04,
			"r": "30",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.76,
			"r": "88",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.69,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.01,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.41,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.1,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.45,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.84,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.87,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.9,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.33,
			"r": "27",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.83,
			"r": "84",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.9,
			"r": "9",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.16,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.96,
			"r": "131",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.92,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.73,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.99,
			"r": "130",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.04,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.96,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.98,
			"r": "75",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.16,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.36,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.34,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.13,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.3,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.34,
			"r": "52",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.25,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.27,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.74,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.26,
			"r": "138",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.36,
			"r": "112",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.77,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.45,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.37,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.52,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.68,
			"r": "94",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.51,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.18,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.27,
			"r": "81",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.24,
			"r": "124",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.35,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.39,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.29,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.35,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.78,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.46,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.05,
			"r": "73",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.91,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.52,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.26,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.69,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.26,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.69,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.95,
			"r": "77",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.61,
			"r": "98",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.86,
			"r": "52",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.81,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.49,
			"r": "72",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.99,
			"r": "11",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.59,
			"r": "102",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.22,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.8,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.31,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.8,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.83,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.75,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.6,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.49,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.58,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.09,
			"r": "7",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.14,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.3,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.35,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.63,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.14,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.22,
			"r": "138",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.51,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.74,
			"r": "135",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.98,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.51,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.74,
			"r": "21",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.7,
			"r": "92",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.29,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.32,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.82,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.04,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.09,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.09,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.4,
			"r": "108",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.27,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.32,
			"r": "118",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.89,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.83,
			"r": "36",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.46,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.33,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.22,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.99,
			"r": "129",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.84,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.76,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.49,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.24,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.37,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.85,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.6,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.23,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.76,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.42,
			"r": "85",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.53,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.93,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.17,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.93,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.33,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.45,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.25,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.86,
			"r": "16",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.66,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.94,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.6,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.8,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.84,
			"r": "83",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.18,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.71,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.64,
			"r": "96",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.37,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.67,
			"r": "40",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.27,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.7,
			"r": "24",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.93,
			"r": "132",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.78,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.64,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.75,
			"r": "89",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.3,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.28,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.29,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.46,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.59,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.41,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.86,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.15,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.15,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.41,
			"r": "48",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ext_cooperation": {
		"UNK": null,
		"NOR": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 2,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.5,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"MLT": null,
		"BVT": null,
		"GTM": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 0.5,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"BRN": null,
		"CHL": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 0.25,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.67,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 2,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 1.33,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": null,
		"BWA": {
			"v": 1.25,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": null,
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.67,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": null,
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": null,
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.5,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 2,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TARIFDISP": {
		"UNK": null,
		"NOR": {
			"v": 35.89,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 7.16,
			"r": "64",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 11.81,
			"r": "112",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 5.61,
			"r": "14",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.52,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 23,
			"r": "130",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 51.28,
			"r": "135",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 8.08,
			"r": "82",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 12.61,
			"r": "116",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 6.99,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 6.32,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 20.4,
			"r": "128",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.9,
			"r": "58",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 7.29,
			"r": "69",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.97,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 8.55,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 10.34,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 9.36,
			"r": "91",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.55,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 11.72,
			"r": "110",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 11.49,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 11.28,
			"r": "103",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 7.68,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.35,
			"r": "7",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0.29,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5.28,
			"r": "12",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 7.45,
			"r": "75",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 9.89,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 11.82,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 7.37,
			"r": "70",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 5.7,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 28.36,
			"r": "132",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 12.2,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 141.83,
			"r": "136",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 6.87,
			"r": "30",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 9.13,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 16.14,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 7.21,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 37.09,
			"r": "134",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 8.44,
			"r": "84",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 14.72,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7.74,
			"r": "79",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 11.75,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 9.04,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 11.21,
			"r": "102",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 7.86,
			"r": "80",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.87,
			"r": "30",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 9.66,
			"r": "95",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 6.18,
			"r": "21",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 2.62,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 16.96,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 7.4,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 14.01,
			"r": "118",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 8.56,
			"r": "87",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 6.87,
			"r": "30",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 7.27,
			"r": "68",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 11.46,
			"r": "105",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 6.38,
			"r": "23",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 7.87,
			"r": "81",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 6.74,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 18.49,
			"r": "125",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8.98,
			"r": "88",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5.99,
			"r": "20",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 11.67,
			"r": "109",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 11.02,
			"r": "101",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 9.47,
			"r": "93",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 7.53,
			"r": "76",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 10.18,
			"r": "99",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 5.22,
			"r": "11",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 7.4,
			"r": "71",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 9.82,
			"r": "97",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 9.47,
			"r": "94",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 6.87,
			"r": "30",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 5.7,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.96,
			"r": "9",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 11.38,
			"r": "104",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.71,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 6.44,
			"r": "24",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "19",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 9.76,
			"r": "96",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 7,
			"r": "62",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 14.58,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 13.06,
			"r": "117",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 7.24,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 6.86,
			"r": "29",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 7.18,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 7.6,
			"r": "77",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 5.66,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 25.38,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 15.89,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3.89,
			"r": "8",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 5.07,
			"r": "10",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 1.11,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 7.4,
			"r": "71",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 8.37,
			"r": "83",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 22.37,
			"r": "129",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 8.45,
			"r": "85",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 11.49,
			"r": "106",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 7.04,
			"r": "63",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 5.71,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 6.65,
			"r": "26",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 19.61,
			"r": "127",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 5.42,
			"r": "13",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 7.4,
			"r": "71",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 9.46,
			"r": "92",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0.72,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 11.88,
			"r": "114",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.97,
			"r": "60",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 19.23,
			"r": "126",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 2.77,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 14.25,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ366": {
		"UNK": null,
		"NOR": {
			"v": 5.87,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.22,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.92,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.8,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.03,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.72,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.71,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.05,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.82,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.9,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.85,
			"r": "50",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.12,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.57,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.62,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.58,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.72,
			"r": "13",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.53,
			"r": "69",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.24,
			"r": "32",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.53,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.43,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.38,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.58,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.33,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.57,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.87,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.24,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.49,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.25,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.71,
			"r": "14",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.97,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.64,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.13,
			"r": "37",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.62,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.92,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.12,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.59,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.3,
			"r": "77",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.13,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.3,
			"r": "31",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.36,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.61,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.64,
			"r": "117",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.11,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.82,
			"r": "107",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.1,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.05,
			"r": "96",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 5.02,
			"r": "40",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.19,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.96,
			"r": "101",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.53,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.76,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.01,
			"r": "41",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.61,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.78,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.06,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.86,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.27,
			"r": "75",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.42,
			"r": "123",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.33,
			"r": "74",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.03,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.94,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.28,
			"r": "32",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.47,
			"r": "123",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.73,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.51,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.32,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.59,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.01,
			"r": "96",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.86,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.96,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.55,
			"r": "120",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.37,
			"r": "73",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.4,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.74,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.74,
			"r": "110",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.22,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.43,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.7,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.29,
			"r": "78",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.99,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.68,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.2,
			"r": "131",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.44,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.27,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.81,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.86,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.59,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.53,
			"r": "138",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.52,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.3,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.07,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.17,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.42,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.42,
			"r": "125",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.23,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.61,
			"r": "118",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.29,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 3.87,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.05,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.72,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.11,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.76,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.51,
			"r": "25",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.41,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.87,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.69,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.73,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.64,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.09,
			"r": "89",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.66,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.91,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.31,
			"r": "128",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.57,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.54,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.09,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.08,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.26,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.9,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.14,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.38,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.9,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.87,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.29,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.81,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.15,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.58,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.87,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.63,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.6,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.09,
			"r": "91",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.63,
			"r": "18",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "98",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.77,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.64,
			"r": "17",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.28,
			"r": "80",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.31,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.18,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.72,
			"r": "56",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.55,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.98,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.37,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.66,
			"r": "140",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.8,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.08,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.69,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.56,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.01,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.26,
			"r": "81",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TRACKTRACE": {
		"UNK": null,
		"NOR": {
			"v": 3.82,
			"r": "22",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.16,
			"r": "52",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.48,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.84,
			"r": "21",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.68,
			"r": "83",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.32,
			"r": "44",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.18,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.65,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 4.02,
			"r": "15",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.78,
			"r": "24",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.14,
			"r": "123",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.38,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.84,
			"r": "73",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.12,
			"r": "56",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.46,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.46,
			"r": "36",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.02,
			"r": "129",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.75,
			"r": "79",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.47,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.32,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.72,
			"r": "26",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.7,
			"r": "81",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.86,
			"r": "72",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.42,
			"r": "38",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.92,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.4,
			"r": "42",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.78,
			"r": "75",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.68,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.95,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.91,
			"r": "68",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.5,
			"r": "34",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.42,
			"r": "39",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.21,
			"r": "118",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.21,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.7,
			"r": "82",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.65,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.04,
			"r": "11",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.47,
			"r": "101",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.01,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "124",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.37,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.44,
			"r": "103",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.63,
			"r": "87",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.15,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.72,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.91,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.2,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.39,
			"r": "105",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 1.85,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 4.04,
			"r": "12",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.28,
			"r": "45",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.96,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.77,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.04,
			"r": "58",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.27,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.9,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.63,
			"r": "88",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.28,
			"r": "116",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.05,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 2.95,
			"r": "63",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.22,
			"r": "4",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.07,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.04,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.87,
			"r": "19",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.34,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.4,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.62,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.82,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.2,
			"r": "119",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 3.26,
			"r": "47",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.13,
			"r": "7",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.86,
			"r": "70",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.89,
			"r": "69",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.67,
			"r": "85",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.19,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.74,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.53,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.54,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.76,
			"r": "77",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.31,
			"r": "114",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.03,
			"r": "14",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.37,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.92,
			"r": "17",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.84,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.54,
			"r": "94",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.12,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.07,
			"r": "125",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.56,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.98,
			"r": "16",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.46,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.38,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2,
			"r": "131",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.86,
			"r": "71",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.59,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.15,
			"r": "121",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 2.36,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.09,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.16,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.86,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.17,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.59,
			"r": "91",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.36,
			"r": "2",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.5,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.34,
			"r": "111",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 1.77,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.75,
			"r": "78",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.3,
			"r": "115",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.25,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.44,
			"r": "104",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.36,
			"r": "109",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 1.54,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.49,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.52,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.67,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.92,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.52,
			"r": "97",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.62,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.25,
			"r": "48",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.68,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.2,
			"r": "5",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.39,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.03,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.94,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.27,
			"r": "3",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.96,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.05,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.23,
			"r": "117",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.55,
			"r": "93",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.42,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 1.76,
			"r": "134",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.12,
			"r": "8",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.52,
			"r": "96",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.74,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.91,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.56,
			"r": "92",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.57,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.95,
			"r": "132",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.16,
			"r": "53",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.15,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.04,
			"r": "128",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.47,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.98,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.01,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.1,
			"r": "9",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.58,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.59,
			"r": "31",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ033": {
		"UNK": null,
		"NOR": {
			"v": 5.85,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 6.16,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 4.9,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.96,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.43,
			"r": "108",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.77,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.2,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.61,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.28,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.99,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.82,
			"r": "32",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.21,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.52,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.39,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.34,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.08,
			"r": "78",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.8,
			"r": "33",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.95,
			"r": "31",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.33,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 6.28,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.77,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.39,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.76,
			"r": "95",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.1,
			"r": "120",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.58,
			"r": "137",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.71,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.79,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.01,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.63,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.67,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.27,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.87,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.14,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 5.21,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 4.77,
			"r": "96",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.96,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 6.12,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.43,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.36,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.7,
			"r": "123",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.25,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.25,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.5,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 6.23,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 4.95,
			"r": "105",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.66,
			"r": "135",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.45,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.7,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.01,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.18,
			"r": "118",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.43,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.87,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.21,
			"r": "10",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.54,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.94,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.23,
			"r": "9",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.88,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.96,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 6.21,
			"r": "15",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 5.78,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.15,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.51,
			"r": "112",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.96,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 6.6,
			"r": "3",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.85,
			"r": "87",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 5.37,
			"r": "61",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 5.02,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.41,
			"r": "55",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.65,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.83,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.6,
			"r": "105",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.9,
			"r": "84",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.37,
			"r": "60",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.65,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 5.53,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.57,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.8,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 5.54,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.22,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.09,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.42,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 5.47,
			"r": "62",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 5.55,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 5.86,
			"r": "29",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.19,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5.38,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.31,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.17,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.48,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.83,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.64,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 5.18,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.11,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.48,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.04,
			"r": "20",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.35,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.55,
			"r": "102",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.35,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.4,
			"r": "56",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.25,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.09,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 5.54,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 5.07,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.4,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.21,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.8,
			"r": "35",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.09,
			"r": "17",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.03,
			"r": "130",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.74,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.5,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.69,
			"r": "38",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.77,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.87,
			"r": "128",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.01,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.23,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.13,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.84,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.58,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.18,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.97,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.52,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.12,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.08,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.48,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.21,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.62,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.74,
			"r": "97",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.93,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.35,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.98,
			"r": "82",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.66,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.16,
			"r": "14",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.66,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.27,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.16,
			"r": "73",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.23,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 6.35,
			"r": "5",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.29,
			"r": "66",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.82,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.65,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 6.08,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 4.91,
			"r": "92",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.71,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.76,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.28,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.69,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.66,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.86,
			"r": "27",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 5": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"LOGICOMP": {
		"UNK": null,
		"NOR": {
			"v": 3.7,
			"r": "24",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.21,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.34,
			"r": "110",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.65,
			"r": "26",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.46,
			"r": "102",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.38,
			"r": "33",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.37,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.66,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.82,
			"r": "19",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.69,
			"r": "25",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.14,
			"r": "123",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.31,
			"r": "113",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 3.01,
			"r": "53",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.85,
			"r": "67",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.3,
			"r": "116",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.34,
			"r": "35",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.21,
			"r": "121",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.44,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.55,
			"r": "94",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.36,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.6,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.6,
			"r": "87",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.7,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.24,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.16,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.14,
			"r": "48",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.66,
			"r": "83",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.49,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.82,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.57,
			"r": "91",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 2.97,
			"r": "56",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.29,
			"r": "37",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.21,
			"r": "120",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.31,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.74,
			"r": "74",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.15,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.88,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.13,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.93,
			"r": "57",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "130",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.31,
			"r": "114",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.67,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.86,
			"r": "66",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.2,
			"r": "43",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.06,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.82,
			"r": "70",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.14,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1.96,
			"r": "132",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.5,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.95,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.12,
			"r": "50",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.89,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.55,
			"r": "92",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.87,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.2,
			"r": "44",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.66,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.68,
			"r": "79",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.28,
			"r": "118",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.39,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.18,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.07,
			"r": "6",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.12,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.12,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.87,
			"r": "17",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.59,
			"r": "89",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.35,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.62,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.73,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.3,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.83,
			"r": "68",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.05,
			"r": "7",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.57,
			"r": "90",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.74,
			"r": "75",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.48,
			"r": "99",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 4.01,
			"r": "9",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.44,
			"r": "105",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.54,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.91,
			"r": "61",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 1.9,
			"r": "134",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.33,
			"r": "111",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.75,
			"r": "22",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.88,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.72,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.12,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.06,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.68,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.79,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.39,
			"r": "31",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.25,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.22,
			"r": "119",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.91,
			"r": "59",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.91,
			"r": "60",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.48,
			"r": "97",
			"m": 52,
			"y": "2015"
		},
		"MLI": {
			"v": 2.46,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.26,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.32,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.77,
			"r": "21",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.22,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.67,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.18,
			"r": "4",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.54,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.48,
			"r": "98",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.15,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.45,
			"r": "103",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.69,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.08,
			"r": "129",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.42,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 1.74,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.78,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.39,
			"r": "32",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.59,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.79,
			"r": "71",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.54,
			"r": "95",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.76,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.18,
			"r": "46",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.62,
			"r": "27",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.01,
			"r": "8",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.31,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.99,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.87,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.28,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.55,
			"r": "93",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.09,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.47,
			"r": "100",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.67,
			"r": "81",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.26,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.1,
			"r": "128",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.01,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.63,
			"r": "85",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.85,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.82,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.52,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.36,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.13,
			"r": "125",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 2.79,
			"r": "72",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.39,
			"r": "107",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.32,
			"r": "112",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.31,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.92,
			"r": "58",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.93,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.9,
			"r": "15",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.22,
			"r": "41",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.95,
			"r": "13",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"GOVONLINESERVIDX": {
		"UNK": null,
		"NOR": {
			"v": 0.8,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.75,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.43,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.48,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 0.15,
			"r": "122",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 0.83,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 0.53,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 0.63,
			"r": "57",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.94,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 0.94,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.68,
			"r": "47",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 0.36,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 0.78,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0.8,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 0.67,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.72,
			"r": "40",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.43,
			"r": "97",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 0.2,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 0.38,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 0.61,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 0.86,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.05,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.67,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.56,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 0.14,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 0.85,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.49,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0.83,
			"r": "22",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.46,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.51,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 0.78,
			"r": "28",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.61,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 0.14,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 0.46,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.35,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 0.41,
			"r": "99",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0.75,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.94,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.4,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.5,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 0.24,
			"r": "115",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.68,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 0.33,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 0.22,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.32,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 0.47,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.57,
			"r": "74",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.33,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 0.55,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 0.43,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 0.11,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 0.6,
			"r": "64",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 0.73,
			"r": "37",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 0.46,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.64,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 0.46,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.85,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 0.28,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 0.3,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 0.51,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.53,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.69,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 0.33,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.71,
			"r": "43",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 0.15,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 0.12,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 0.98,
			"r": "2",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.74,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.63,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 0.41,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 0.19,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.91,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.32,
			"r": "109",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 0.71,
			"r": "43",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.77,
			"r": "31",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 0.28,
			"r": "111",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 0.59,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 0.36,
			"r": "104",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.78,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.31,
			"r": "110",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 0.09,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 0.65,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 0.49,
			"r": "86",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 0.09,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 0.56,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 0.57,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.54,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.44,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 0.14,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 0.17,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 0.72,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.7,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.88,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.2,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.07,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.58,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.59,
			"r": "67",
			"m": 60,
			"y": "2016"
		},
		"MLI": {
			"v": 0.09,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 0.59,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.28,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0.49,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.87,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.93,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.62,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.91,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.67,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.7,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 0.3,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 0.51,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.6,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 0.67,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 0.64,
			"r": "55",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 0.37,
			"r": "103",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 0.07,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 0.19,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 0.75,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 0.72,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 0.82,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 0.45,
			"r": "93",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.73,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.89,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.77,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 0.93,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.6,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 0.88,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.63,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0.84,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.59,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 0.97,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.14,
			"r": "124",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 0.79,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 0.62,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 0.28,
			"r": "111",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.72,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 0.28,
			"r": "111",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 0.12,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 0.89,
			"r": "13",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 0.45,
			"r": "93",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 0.16,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.26,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 0.65,
			"r": "53",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 0.38,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 0.22,
			"r": "117",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 0.51,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 0.22,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 0.57,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.22,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 0.96,
			"r": "4",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 0.94,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"TWN": null,
		"BRB": {
			"v": 0.44,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ088": {
		"UNK": null,
		"NOR": {
			"v": 5.19,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.41,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.88,
			"r": "71",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.4,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.41,
			"r": "131",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.7,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.14,
			"r": "108",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.26,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.48,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.3,
			"r": "100",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.63,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.28,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.51,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.71,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "25",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.92,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.8,
			"r": "73",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.21,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.85,
			"r": "67",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.33,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.67,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.78,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.29,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.27,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 1.73,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.79,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.2,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.13,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.6,
			"r": "85",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.83,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.51,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.18,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.16,
			"r": "122",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.6,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.66,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.19,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.14,
			"r": "54",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.6,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.39,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.8,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.65,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.31,
			"r": "106",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 1.86,
			"r": "129",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 4.08,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.28,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.48,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.63,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.52,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.15,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.6,
			"r": "84",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.87,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.31,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.04,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.18,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.33,
			"r": "37",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 2.35,
			"r": "111",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.12,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.75,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.68,
			"r": "96",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.22,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.35,
			"r": "101",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.96,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.97,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.11,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.08,
			"r": "14",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.58,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.61,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.6,
			"r": "25",
			"m": 104,
			"y": "2013"
		},
		"CIV": {
			"v": 2.69,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.57,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.99,
			"r": "66",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.97,
			"r": "116",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.27,
			"r": "48",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.56,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.94,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.07,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.67,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.13,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.27,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.19,
			"r": "119",
			"m": 95,
			"y": "2013"
		},
		"CAF": null,
		"LKA": {
			"v": 4.12,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.47,
			"r": "34",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.49,
			"r": "5",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 2.96,
			"r": "118",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.17,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.62,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2.55,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.75,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.56,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.33,
			"r": "112",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 3.5,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.34,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.38,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.95,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.88,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 1.75,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.19,
			"r": "105",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.43,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.67,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 2.7,
			"r": "81",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 2.98,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.19,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.4,
			"r": "95",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.84,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.6,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.34,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.43,
			"r": "36",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.38,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.05,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.23,
			"r": "51",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.42,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.05,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 1.64,
			"r": "138",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.42,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.29,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.85,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.25,
			"r": "103",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.98,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.57,
			"r": "30",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.47,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.31,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.1,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.34,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.43,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.05,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.03,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.47,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.58,
			"r": "128",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.07,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.51,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.92,
			"r": "69",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.2,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.81,
			"r": "73",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.6,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.04,
			"r": "16",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.97,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 1.37,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 2.78,
			"r": "123",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.38,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.3,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.35,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.99,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.52,
			"r": "94",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.7,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.94,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.68,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.74,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.38,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.02,
			"r": "112",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"inf_availability": {
		"UNK": null,
		"NOR": {
			"v": 1.41,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.4,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.8,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.9,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.61,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.89,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.8,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.9,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.6,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.8,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.7,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.47,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.4,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.7,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.06,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.9,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.47,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.3,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.4,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.39,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.44,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.22,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1.1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.8,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.7,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.9,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.8,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.56,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.7,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.7,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.12,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.89,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.11,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.89,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.7,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.61,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.9,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.8,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.5,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.78,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.7,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.78,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1.9,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.6,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.25,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.8,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.39,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.61,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.39,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.44,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.9,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.8,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.22,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.6,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.78,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.56,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.6,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.78,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.4,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.7,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.4,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.9,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.7,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.2,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.39,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.8,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.28,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.7,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.39,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.7,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.33,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.75,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.6,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.11,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1.2,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.3,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.44,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.6,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.9,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.83,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.61,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.4,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFACED": {
		"UNK": null,
		"NOR": {
			"v": 3.76,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.54,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 4.73,
			"r": "121",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.53,
			"r": "40",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.58,
			"r": "16",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 4.66,
			"r": "116",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.42,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 3.79,
			"r": "87",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.54,
			"r": "50",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.39,
			"r": "32",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 4.87,
			"r": "128",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 3.88,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 4.61,
			"r": "115",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.53,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 3.77,
			"r": "84",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.88,
			"r": "97",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.91,
			"r": "99",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.34,
			"r": "7",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 3.74,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.93,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.62,
			"r": "68",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.16,
			"r": "1",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.87,
			"r": "25",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.75,
			"r": "80",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.54,
			"r": "14",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.7,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 3.79,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.54,
			"r": "64",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.53,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.86,
			"r": "95",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 2.31,
			"r": "5",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.54,
			"r": "53",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.4,
			"r": "9",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 4.45,
			"r": "113",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.54,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.54,
			"r": "61",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.47,
			"r": "12",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.35,
			"r": "8",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.63,
			"r": "20",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 3.95,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 5.01,
			"r": "134",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.3,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.59,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.53,
			"r": "39",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.83,
			"r": "91",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 4.25,
			"r": "111",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 3.47,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 4.77,
			"r": "122",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.46,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.08,
			"r": "27",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.47,
			"r": "11",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.53,
			"r": "45",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.8,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 3.91,
			"r": "98",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.76,
			"r": "83",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 3.54,
			"r": "63",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 4.69,
			"r": "119",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 4.34,
			"r": "112",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 4.67,
			"r": "117",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.51,
			"r": "36",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.53,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 3.74,
			"r": "78",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.54,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9.62,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 4.79,
			"r": "123",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.54,
			"r": "48",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.86,
			"r": "127",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.74,
			"r": "77",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.66,
			"r": "70",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.32,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.54,
			"r": "49",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 3.76,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.15,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 3.73,
			"r": "76",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.83,
			"r": "124",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.38,
			"r": "31",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.96,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.29,
			"r": "28",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.53,
			"r": "43",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.53,
			"r": "44",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.48,
			"r": "13",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 3.54,
			"r": "60",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.53,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 3.54,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 3.33,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.85,
			"r": "94",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.54,
			"r": "59",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 3.94,
			"r": "101",
			"m": 55,
			"y": "2015"
		},
		"MLI": {
			"v": 2.58,
			"r": "18",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 4.68,
			"r": "118",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 3.54,
			"r": "57",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 3.54,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.81,
			"r": "23",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.54,
			"r": "65",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 4.86,
			"r": "126",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.72,
			"r": "75",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.69,
			"r": "72",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.8,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 4.91,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 3.66,
			"r": "71",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 3.04,
			"r": "26",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.17,
			"r": "110",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 3.84,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 3.97,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 3.81,
			"r": "90",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 4.99,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.54,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "114",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.89,
			"r": "130",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.85,
			"r": "93",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.94,
			"r": "132",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.69,
			"r": "22",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 3.54,
			"r": "58",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 3.45,
			"r": "33",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.68,
			"r": "21",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 3.51,
			"r": "37",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 2.83,
			"r": "24",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.26,
			"r": "2",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 3.54,
			"r": "51",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.72,
			"r": "74",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.61,
			"r": "19",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 4.88,
			"r": "129",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.09,
			"r": "107",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.78,
			"r": "85",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 4.85,
			"r": "125",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.58,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 3.6,
			"r": "67",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 4.1,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.34,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.31,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.69,
			"r": "120",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.94,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 5.06,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA": {
		"UNK": null,
		"NOR": {
			"v": 4.43,
			"r": "78",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.03,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.06,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.97,
			"r": "29",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.89,
			"r": "38",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.26,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.12,
			"r": "96",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.82,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.08,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.57,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.42,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.13,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.69,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.26,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.35,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.46,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.31,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.3,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 5.01,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.77,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.04,
			"r": "23",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.04,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.62,
			"r": "66",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.71,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.09,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.46,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.78,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.94,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.07,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.83,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.76,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.79,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.07,
			"r": "131",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.89,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.64,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.68,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.37,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.1,
			"r": "97",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.97,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.08,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.35,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.09,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.81,
			"r": "48",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.29,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.18,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.73,
			"r": "110",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 4.16,
			"r": "92",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.24,
			"r": "130",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.88,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.08,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.78,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.96,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.56,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.12,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.2,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.87,
			"r": "41",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.86,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.56,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.02,
			"r": "101",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.58,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.91,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.91,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.96,
			"r": "30",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.61,
			"r": "117",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.84,
			"r": "108",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.55,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.29,
			"r": "129",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.5,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.79,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.62,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.82,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 5.34,
			"r": "10",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.32,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.48,
			"r": "76",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.57,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.29,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.51,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.7,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.94,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.7,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.82,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.97,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.7,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.12,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.7,
			"r": "112",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.95,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.18,
			"r": "17",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.35,
			"r": "83",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.07,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.73,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.87,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.35,
			"r": "84",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.9,
			"r": "37",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 3.52,
			"r": "121",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.37,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.36,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.61,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.25,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.95,
			"r": "33",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.9,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.77,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.63,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.86,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.81,
			"r": "109",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3,
			"r": "133",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.83,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.35,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 3.91,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.3,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.68,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.53,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.74,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.38,
			"r": "80",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.49,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.93,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.74,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.37,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.32,
			"r": "11",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.97,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.74,
			"r": "58",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.52,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 3.6,
			"r": "118",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.77,
			"r": "53",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.96,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.62,
			"r": "115",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.55,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.65,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.5,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 5.13,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.24,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.21,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.62,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.46,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ROADQUALIDX": {
		"UNK": null,
		"NOR": {
			"v": 4.02,
			"r": "87",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.34,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 5.62,
			"r": "41",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.18,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.41,
			"r": "109",
			"m": 81,
			"y": "2016"
		},
		"BHR": null,
		"ETH": {
			"v": 2.92,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.97,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.6,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": null,
		"AZE": {
			"v": 4.05,
			"r": "86",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.23,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.49,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": {
			"v": 1.95,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 2.61,
			"r": "123",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.51,
			"r": "108",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.37,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.91,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.87,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 6.01,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.83,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.35,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.46,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.73,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 6.61,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.51,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.07,
			"r": "21",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.97,
			"r": "65",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.68,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 6.44,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.89,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.17,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 4.99,
			"r": "63",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 6.41,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.26,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.06,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.64,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.59,
			"r": "106",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.66,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 5.63,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.9,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.29,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.93,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.02,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.21,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.27,
			"r": "112",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.63,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.82,
			"r": "72",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.3,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.54,
			"r": "107",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 2.63,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.18,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.86,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.77,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.25,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.2,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.12,
			"r": "127",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.09,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.4,
			"r": "16",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.75,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.85,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.41,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.94,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1,
			"r": "129",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 6.56,
			"r": "11",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.83,
			"r": "29",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.14,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 6.46,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.72,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.07,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.71,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.71,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.73,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.39,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 3.8,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 6.65,
			"r": "5",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.66,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.36,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.56,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.83,
			"r": "98",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.58,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.72,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.82,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.98,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.83,
			"r": "30",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.01,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.36,
			"r": "111",
			"m": 64,
			"y": "2016"
		},
		"MLI": {
			"v": 4.35,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.55,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.04,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.93,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.06,
			"r": "117",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.86,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.53,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.92,
			"r": "91",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.84,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 6.96,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.89,
			"r": "69",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.03,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.72,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.89,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.57,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.53,
			"r": "76",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.68,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.68,
			"r": "37",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.3,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.85,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.2,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.9,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.61,
			"r": "6",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.36,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"SGP": null,
		"GRD": null,
		"BEN": {
			"v": 5.46,
			"r": "48",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.88,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.45,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.23,
			"r": "126",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": {
			"v": 6.57,
			"r": "10",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.45,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.77,
			"r": "32",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.95,
			"r": "90",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 5.81,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.49,
			"r": "47",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.3,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.6,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.71,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.29,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.37,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.6,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.2,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.95,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI_PROPERTYPROTECT": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EGY": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 1.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 4.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 2.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 125,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1250,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 105.86,
			"r": "31",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 47.22,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 144,
			"r": "37",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 560,
			"r": "112",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 184.72,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 214.14,
			"r": "52",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 876,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 1095,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 325,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 310,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 321.16,
			"r": "77",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "29",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 601.67,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 150,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 102.5,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 150,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 375,
			"r": "86",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 456,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 142.5,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 150,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 400,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 128.33,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 58,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 340,
			"r": "82",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 290,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 150,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 630,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 735,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 785.71,
			"r": "125",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 212.5,
			"r": "51",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 287.86,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 286.88,
			"r": "65",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 755,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 158.18,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 565.38,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 242.94,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 710,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 258,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 55,
			"r": "21",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 426.43,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 222.56,
			"r": "53",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 445,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 575,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 200.56,
			"r": "50",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 958.7,
			"r": "129",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 131.29,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 375,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 183.33,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 378,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 468,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 487.5,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 498.5,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 278,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 270,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 1633,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 313.33,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 749,
			"r": "121",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 155.77,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 332,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 387.07,
			"r": "92",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 59.17,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 150,
			"r": "38",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 280,
			"r": "62",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 573.5,
			"r": "114",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 316.54,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 76.11,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 253.74,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 601.26,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 778,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 366.11,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 65,
			"r": "25",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 281.82,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2222.69,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 428.33,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 309.13,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 300,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 319,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 368,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 305,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 55,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 380.56,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 592.89,
			"r": "115",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 300,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 54.67,
			"r": "20",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 241.67,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 222.86,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 134,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 108,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 408.17,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 381.67,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 302.62,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 453,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 410,
			"r": "95",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 815,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 264.17,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 383.33,
			"r": "91",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 370,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 749,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 261,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 413.1,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 469.08,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 47.25,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 490,
			"r": "106",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 765,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 522.44,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 175,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 376.38,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 264.86,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 460,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 345,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 75,
			"r": "27",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 335,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 487.44,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 545,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 655,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 73,
			"r": "26",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 745,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 551.86,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 461.67,
			"r": "102",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 106,
			"r": "32",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 432,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 285,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 602,
			"r": "118",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 546.73,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 982.75,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 191.11,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 350,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 1160,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 867.73,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 166.67,
			"r": "45",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 337,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 335.38,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 350,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETI_FINANCE": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 4": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 2.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 1.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 6.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 6.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 1.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-EOSQ147": {
		"UNK": null,
		"NOR": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 2.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 2.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 5.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 2.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 2.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 2.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 2.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 2.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 1.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 6.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 1.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TARIFCOMPL": {
		"UNK": null,
		"NOR": {
			"v": 3.12,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 6.57,
			"r": "32",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 6.38,
			"r": "46",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 6.69,
			"r": "13",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 6.5,
			"r": "37",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 4.96,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 5.02,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 6.1,
			"r": "64",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 5.48,
			"r": "74",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 6.66,
			"r": "23",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 6.66,
			"r": "24",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 4.46,
			"r": "97",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.72,
			"r": "102",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.68,
			"r": "16",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.56,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.26,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 5.17,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 5.54,
			"r": "71",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.18,
			"r": "61",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 6.39,
			"r": "45",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 4.9,
			"r": "87",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 6.23,
			"r": "59",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 6.37,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 5.25,
			"r": "78",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 6.99,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.13,
			"r": "62",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 6.68,
			"r": "21",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 6.35,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.38,
			"r": "48",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 6.29,
			"r": "56",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 5.12,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 5.16,
			"r": "80",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 6.46,
			"r": "38",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.4,
			"r": "76",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.99,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 6.37,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 4.23,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.49,
			"r": "104",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 1.74,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 6.62,
			"r": "26",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 4.86,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.45,
			"r": "39",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 6.38,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 6.53,
			"r": "36",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 5.53,
			"r": "72",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.44,
			"r": "40",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 2.99,
			"r": "108",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 6.58,
			"r": "31",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 6.3,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 6.82,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.63,
			"r": "69",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 6.68,
			"r": "17",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.3,
			"r": "54",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 6.62,
			"r": "27",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 2.99,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.47,
			"r": "106",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 4.9,
			"r": "88",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 5.45,
			"r": "75",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 6.27,
			"r": "57",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 6.61,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 5.49,
			"r": "73",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 6.12,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 6.74,
			"r": "6",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 4.9,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 5.73,
			"r": "68",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 6.59,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 6.67,
			"r": "22",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 6.56,
			"r": "34",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 5.57,
			"r": "70",
			"m": 55,
			"y": "2015"
		},
		"MLI": {
			"v": 6.68,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 6.43,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 6.53,
			"r": "35",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 2.99,
			"r": "108",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 6.69,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.07,
			"r": "82",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.83,
			"r": "92",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.69,
			"r": "12",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 6.65,
			"r": "25",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 4.43,
			"r": "98",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 6.24,
			"r": "58",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 6.7,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.92,
			"r": "85",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 6.44,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 6.01,
			"r": "65",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 6.7,
			"r": "7",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 3.48,
			"r": "105",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 6.4,
			"r": "43",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.7,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.24,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.11,
			"r": "101",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 5.78,
			"r": "67",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 5.93,
			"r": "66",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 6.94,
			"r": "3",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 6.68,
			"r": "17",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 6.39,
			"r": "44",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 4.51,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 6.18,
			"r": "60",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 4.9,
			"r": "86",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 6.69,
			"r": "11",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 6.69,
			"r": "15",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.72,
			"r": "93",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 4.52,
			"r": "95",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 6.7,
			"r": "9",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 6.68,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 6.59,
			"r": "29",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 6.92,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 6.37,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.7,
			"r": "8",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 4.67,
			"r": "94",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 6.3,
			"r": "53",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 4.88,
			"r": "90",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"RAILROADQUALITY": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.73,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.48,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"BDI": null,
		"BHR": null,
		"ETH": {
			"v": 3.4,
			"r": "48",
			"m": 94,
			"y": "2016"
		},
		"ECU": null,
		"FRA": {
			"v": 5.84,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.52,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.15,
			"r": "29",
			"m": 81,
			"y": "2016"
		},
		"JAM": null,
		"SLB": null,
		"URY": {
			"v": 1.23,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": {
			"v": 5.06,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.74,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.43,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"NIC": null,
		"MKD": {
			"v": 2.74,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.48,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 1.62,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.97,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.84,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 2.91,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"SLV": null,
		"CYM": null,
		"LTU": {
			"v": 4.46,
			"r": "24",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.4,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"BRN": null,
		"CHL": {
			"v": 2.39,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.08,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1.48,
			"r": "103",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.16,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.66,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.59,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.76,
			"r": "65",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.91,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.48,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 2.61,
			"r": "73",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.08,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2.52,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.37,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.57,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.89,
			"r": "93",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2.53,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.76,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 2.97,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.25,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.88,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.96,
			"r": "36",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.92,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.55,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.59,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 2.13,
			"r": "87",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.26,
			"r": "26",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.24,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.7,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.82,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.7,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.59,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.91,
			"r": "92",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.36,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 1.54,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.8,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.15,
			"r": "52",
			"m": 105,
			"y": "2016"
		},
		"CYP": null,
		"TCA": null,
		"SVK": {
			"v": 4.58,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 3.98,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.34,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.97,
			"r": "57",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.84,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 1.35,
			"r": "105",
			"m": 63,
			"y": "2016"
		},
		"MLI": {
			"v": 2.19,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.11,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.64,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.65,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 2.99,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.85,
			"r": "38",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.97,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.48,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.81,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.15,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 1.77,
			"r": "96",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.02,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.07,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.03,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.66,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 1.92,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.36,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.74,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 1.56,
			"r": "100",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 1.4,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 5.06,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.24,
			"r": "50",
			"m": 101,
			"y": "2016"
		},
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": {
			"v": 2.05,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.28,
			"r": "83",
			"m": 105,
			"y": "2016"
		},
		"KWT": null,
		"ESH": null,
		"SEN": {
			"v": 2.17,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.36,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.73,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.53,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.81,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.83,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.41,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.39,
			"r": "10",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ360": {
		"UNK": null,
		"NOR": {
			"v": 4.88,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.92,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.05,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.36,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.53,
			"r": "136",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.93,
			"r": "28",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.88,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.64,
			"r": "88",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.92,
			"r": "29",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.9,
			"r": "30",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.48,
			"r": "42",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.85,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.94,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.94,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.55,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.36,
			"r": "13",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.81,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.93,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.18,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.9,
			"r": "129",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.39,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.68,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.51,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.06,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.06,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.55,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.96,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.55,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.66,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.99,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.71,
			"r": "32",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.52,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.62,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.6,
			"r": "89",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.88,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.37,
			"r": "137",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.6,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.86,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.02,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.5,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.42,
			"r": "106",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.79,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.68,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.21,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.9,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "87",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.69,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.32,
			"r": "110",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.55,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.71,
			"r": "6",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.65,
			"r": "133",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.21,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.48,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.47,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.21,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.05,
			"r": "58",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.25,
			"r": "110",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.06,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.85,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.47,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.19,
			"r": "20",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.95,
			"r": "126",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.21,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.7,
			"r": "33",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.91,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.37,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 5.14,
			"r": "20",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.75,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.4,
			"r": "45",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.57,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.75,
			"r": "131",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.34,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.29,
			"r": "50",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.06,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.23,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.03,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.23,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.7,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.99,
			"r": "139",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.26,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.94,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.32,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.8,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.12,
			"r": "58",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.59,
			"r": "90",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.33,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.04,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.6,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.21,
			"r": "138",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.66,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.43,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.1,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.17,
			"r": "120",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.54,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.42,
			"r": "105",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.33,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.18,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.73,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.58,
			"r": "93",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.01,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.59,
			"r": "91",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.12,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.26,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.66,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.41,
			"r": "107",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.33,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.96,
			"r": "26",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.68,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.73,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.26,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.56,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.08,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.26,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "81",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.26,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.05,
			"r": "22",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "41",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.49,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.48,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.46,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.43,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.24,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.77,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.25,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.19,
			"r": "118",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.27,
			"r": "113",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.35,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.58,
			"r": "92",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.55,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "51",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.74,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.95,
			"r": "4",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.93,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.87,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.05,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.82,
			"r": "76",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.04,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.28,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.25,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.49,
			"r": "136",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.46,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.16,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.25,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.98,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.55,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.01,
			"r": "23",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC06": {
		"UNK": null,
		"NOR": {
			"v": 6.37,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.1,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.9,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.52,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1.73,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.99,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 2.3,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.84,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.04,
			"r": "21",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.44,
			"r": "6",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.19,
			"r": "48",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.98,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.48,
			"r": "36",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.84,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.87,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.51,
			"r": "35",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.31,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.34,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.25,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.77,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.88,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.35,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.33,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.64,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.87,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.52,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.84,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.81,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.57,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.23,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.54,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.28,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.42,
			"r": "102",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.32,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.44,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.02,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.6,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.54,
			"r": "122",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.94,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.46,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.96,
			"r": "86",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5.15,
			"r": "50",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.5,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.69,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.76,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.17,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.25,
			"r": "45",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.36,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.17,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 2.95,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.45,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.81,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.78,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.28,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.82,
			"r": "26",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.31,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.75,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.3,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.67,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.13,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.38,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.73,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.39,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 5.14,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.69,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.25,
			"r": "46",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.84,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.39,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.89,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.46,
			"r": "4",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.11,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.95,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.52,
			"r": "98",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.26,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 1.82,
			"r": "134",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.7,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.58,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.37,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.53,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.63,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.27,
			"r": "44",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.51,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.13,
			"r": "110",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.3,
			"r": "108",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.92,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.28,
			"r": "78",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.97,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.97,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.61,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.49,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.07,
			"r": "112",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.09,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.69,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.71,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.39,
			"r": "72",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.93,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.36,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.61,
			"r": "65",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.76,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.49,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 3.43,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.58,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.21,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4,
			"r": "83",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.46,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.33,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.66,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.18,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.38,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.42,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.15,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.15,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.38,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.47,
			"r": "126",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.77,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.09,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.36,
			"r": "128",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.28,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.48,
			"r": "99",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.46,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.09,
			"r": "19",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.08,
			"r": "82",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.3,
			"r": "42",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.35,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.52,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.99,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.82,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.07,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.65,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.33,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.98,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC0404": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC": {
		"UNK": null,
		"NOR": {
			"v": 5.1,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.41,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.05,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.54,
			"r": "130",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.94,
			"r": "34",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 2.98,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "72",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.86,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.8,
			"r": "10",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.25,
			"r": "55",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.59,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.22,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.77,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.39,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.17,
			"r": "22",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.51,
			"r": "92",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.84,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.09,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.92,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.04,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.21,
			"r": "106",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.54,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.79,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.72,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.29,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.94,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.84,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.84,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.62,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.64,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.48,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.08,
			"r": "110",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.01,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.65,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.78,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.05,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.74,
			"r": "125",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.75,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.56,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.62,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.13,
			"r": "63",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.34,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.44,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.02,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.73,
			"r": "11",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.22,
			"r": "58",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.08,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.84,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.48,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.58,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.75,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.77,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.44,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.6,
			"r": "15",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.9,
			"r": "120",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.92,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.5,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.33,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.49,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.49,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.68,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.03,
			"r": "114",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.14,
			"r": "62",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.02,
			"r": "5",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.25,
			"r": "54",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.83,
			"r": "77",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.61,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.91,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.54,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.21,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.94,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.04,
			"r": "113",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.19,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.33,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.67,
			"r": "38",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.11,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.24,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.21,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.03,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.64,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.72,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.26,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.35,
			"r": "98",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.41,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.5,
			"r": "93",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.98,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.64,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.08,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.14,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.1,
			"r": "108",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.5,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.17,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.15,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.72,
			"r": "85",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.31,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.79,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.84,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.01,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.44,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.19,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.72,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.03,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "94",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.46,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.01,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.06,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.93,
			"r": "8",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.48,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.07,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.67,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.99,
			"r": "7",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.93,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.15,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.79,
			"r": "123",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.83,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.04,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.66,
			"r": "127",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.59,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.77,
			"r": "81",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.51,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6,
			"r": "6",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.24,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.88,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.25,
			"r": "56",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.22,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.62,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.25,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.15,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.36,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.44,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.11,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.57,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ095": {
		"UNK": null,
		"NOR": {
			"v": 5.18,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.92,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.66,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.3,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.2,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.49,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.68,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.05,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.85,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.16,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.39,
			"r": "84",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.37,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.65,
			"r": "11",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.35,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.35,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.02,
			"r": "41",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.34,
			"r": "88",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.02,
			"r": "23",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.45,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.79,
			"r": "55",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.14,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.04,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.44,
			"r": "80",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.15,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.36,
			"r": "86",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.94,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.18,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.13,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.65,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.13,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.07,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.41,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.98,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.31,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.6,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.61,
			"r": "141",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 5.13,
			"r": "33",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.53,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.02,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.7,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.15,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.62,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.17,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.18,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.71,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.63,
			"r": "121",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.78,
			"r": "114",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.86,
			"r": "112",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.95,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.79,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.75,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.96,
			"r": "135",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.62,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.07,
			"r": "104",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.52,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.96,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.75,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.94,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.45,
			"r": "72",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.8,
			"r": "112",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 5.02,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.84,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 5.09,
			"r": "74",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.67,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.87,
			"r": "112",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.52,
			"r": "16",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.56,
			"r": "72",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.91,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.85,
			"r": "49",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.05,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.05,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.11,
			"r": "101",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.78,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.79,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.49,
			"r": "125",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.47,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.96,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.23,
			"r": "92",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.75,
			"r": "60",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.15,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.3,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.44,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.82,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.41,
			"r": "127",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.63,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.57,
			"r": "123",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.39,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 4.68,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.74,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.2,
			"r": "94",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.74,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.52,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.24,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.66,
			"r": "117",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.43,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.64,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.05,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.77,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.96,
			"r": "135",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.84,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.77,
			"r": "59",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.63,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.15,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.4,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.37,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.55,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.53,
			"r": "74",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.4,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.61,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.05,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.44,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.21,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.63,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.36,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.11,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.68,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.62,
			"r": "53",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.58,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.31,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.1,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.55,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.54,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.67,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.43,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.94,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.94,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.08,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.18,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.84,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.24,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.11,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.16,
			"r": "96",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.51,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.59,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.88,
			"r": "111",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.9,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.47,
			"r": "77",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.46,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.54,
			"r": "14",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.44,
			"r": "127",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.47,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.23,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.21,
			"r": "131",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.32,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.41,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.59,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.61,
			"r": "119",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.21,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.98,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.85,
			"r": "48",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.95,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.35,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.72,
			"r": "63",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"form_auto": {
		"UNK": null,
		"NOR": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.5,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.75,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.57,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.25,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.67,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.71,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.75,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.75,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.75,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.8,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.86,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.71,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.43,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.25,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 2,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.43,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.29,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.75,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.43,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.33,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.71,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.75,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.71,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.83,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.75,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.29,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.75,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.25,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.29,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 9": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC05": {
		"UNK": null,
		"NOR": {
			"v": 5.24,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.48,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.83,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.1,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.46,
			"r": "105",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.78,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.41,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "75",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.39,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.25,
			"r": "21",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.58,
			"r": "97",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.42,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.09,
			"r": "63",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.61,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.6,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.98,
			"r": "29",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.35,
			"r": "112",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.54,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.28,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.68,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.08,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.71,
			"r": "87",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.73,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.39,
			"r": "52",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.06,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.17,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.91,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.06,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.96,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.9,
			"r": "77",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.67,
			"r": "39",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.04,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.27,
			"r": "118",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.96,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.61,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.25,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.01,
			"r": "128",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.57,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.71,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.63,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.3,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.11,
			"r": "62",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.02,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.46,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.13,
			"r": "123",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.68,
			"r": "10",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.2,
			"r": "58",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.29,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.77,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.22,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.67,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.6,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.52,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.52,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.73,
			"r": "7",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.9,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.02,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.33,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.99,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.71,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.43,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.21,
			"r": "23",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.5,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.86,
			"r": "80",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.64,
			"r": "11",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.98,
			"r": "68",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.15,
			"r": "61",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.7,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.24,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.28,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.41,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.95,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.12,
			"r": "124",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.91,
			"r": "2",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.15,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.79,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.15,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.31,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.65,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.68,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.35,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.76,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.84,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.42,
			"r": "107",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.74,
			"r": "84",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.44,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.59,
			"r": "95",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.34,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.44,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.83,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.88,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.55,
			"r": "100",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.71,
			"r": "8",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.18,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.99,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.58,
			"r": "96",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.33,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.49,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.57,
			"r": "98",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.49,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.62,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.6,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.64,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.97,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.62,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.77,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.86,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.94,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.55,
			"r": "14",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.53,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.68,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.9,
			"r": "78",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.78,
			"r": "6",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.98,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.9,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.22,
			"r": "120",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.75,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.09,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.19,
			"r": "121",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.92,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.95,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.51,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.57,
			"r": "13",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.28,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.76,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4,
			"r": "65",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.32,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.92,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.38,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.88,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.87,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.39,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.96,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.5,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CUSTTRANSPIND": {
		"UNK": null,
		"NOR": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.93,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.7,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.1,
			"r": "115",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.43,
			"r": "109",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 1,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.9,
			"r": "40",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0.7,
			"r": "86",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 0.73,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.8,
			"r": "66",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.9,
			"r": "40",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": null,
		"NIC": {
			"v": 0.93,
			"r": "36",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 0.5,
			"r": "105",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 0.83,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.07,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.5,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.9,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.5,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.2,
			"r": "112",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 1,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.57,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.93,
			"r": "36",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.73,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.73,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.7,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0.4,
			"y": "2009",
			"m": 96
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.8,
			"y": "2009",
			"m": 87
		},
		"EGY": {
			"v": 0.12,
			"r": "114",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 0.79,
			"r": "78",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 0.88,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 1,
			"r": "1",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 1,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 1,
			"r": "1",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.73,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2009",
			"m": 104
		},
		"DOM": {
			"v": 0.8,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.8,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 1,
			"r": "1",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.7,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"TJK": null,
		"AUS": {
			"v": 1,
			"r": "1",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 0.7,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.8,
			"r": "66",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0.9,
			"r": "40",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.77,
			"r": "79",
			"m": 97,
			"y": "2015"
		},
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 0.53,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.7,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 0.8,
			"r": "66",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 0.7,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 1,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0.6,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.73,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.9,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 0.88,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 1,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.4,
			"y": "2009",
			"m": 92
		},
		"GRC": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.83,
			"r": "63",
			"m": 52,
			"y": "2015"
		},
		"MLI": null,
		"OMN": {
			"v": 0.92,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.4,
			"y": "2009",
			"m": 86
		},
		"ITA": {
			"v": 0.9,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 1,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.38,
			"r": "111",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 1,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.83,
			"r": "63",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.9,
			"r": "40",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.2,
			"r": "112",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.6,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 0.7,
			"r": "86",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.2,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.8,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"TUN": null,
		"SRB": {
			"v": 0.67,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.9,
			"r": "40",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 1,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.9,
			"r": "40",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.9,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.4,
			"r": "110",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 0.9,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": null,
		"SLE": {
			"v": 0.7,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 0.8,
			"r": "66",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 0.8,
			"r": "66",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 0.8,
			"r": "66",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": null,
		"CMR": {
			"v": 0.5,
			"r": "105",
			"m": 92,
			"y": "2015"
		},
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.77,
			"r": "79",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 0.9,
			"r": "40",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 0.8,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"INTLAIRSEATKM": {
		"UNK": null,
		"NOR": {
			"v": 404.48,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 108.12,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 117.6,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 235.9,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1.42,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 177.35,
			"r": "70",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 388.81,
			"r": "52",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 147.77,
			"r": "74",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 3648.21,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 2433.18,
			"r": "14",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 100.39,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 157.27,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 66.38,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 93.73,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 45.01,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 1483.4,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 45.36,
			"r": "100",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 27.1,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 24.92,
			"r": "115",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 22.1,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 569.88,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 103.69,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 979.16,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 248.93,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 0.28,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 1355.33,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 104.57,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 64.12,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 257.72,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 49.97,
			"r": "98",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 463.24,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 76.9,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 0.6,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 254.61,
			"r": "59",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 857.8,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 452.2,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 97.49,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 45.4,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 10.06,
			"r": "129",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 20.86,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 212.46,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 8.14,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 574.06,
			"r": "38",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 125.05,
			"r": "76",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 446.47,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2632.56,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 64.78,
			"r": "90",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 1067.86,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1472.99,
			"r": "21",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 198.88,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 162.56,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 24.22,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 16.21,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 427.85,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 57.1,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 439.8,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 670.89,
			"r": "33",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 32.49,
			"r": "106",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 62.12,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3081.73,
			"r": "9",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 465.89,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 188.1,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 64.6,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3779.58,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.04,
			"r": "133",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 610.27,
			"r": "35",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 7148.08,
			"r": "2",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 161.32,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 7,
			"r": "132",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 29.28,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 1090.59,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 587.06,
			"r": "37",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 24.3,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 351.98,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 52.93,
			"r": "97",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 2767.97,
			"r": "10",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 30.71,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 884.66,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 651.23,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 212.21,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 36.4,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 10.17,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 588.48,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 428.99,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 541.65,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 13.16,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 202.33,
			"r": "65",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 715,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 19.36,
			"r": "122",
			"m": 61,
			"y": "2016"
		},
		"MLI": {
			"v": 32.33,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 299.29,
			"r": "55",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 2188.71,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 1977.01,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 282.98,
			"r": "56",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 511.95,
			"r": "41",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 1682.39,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 197.13,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 180.36,
			"r": "69",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 29.11,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 1400.5,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 55.34,
			"r": "95",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 37.45,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 11.17,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2185.92,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 137.88,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 87.4,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 116.94,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 1390.86,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 27.99,
			"r": "112",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5192.51,
			"r": "4",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 13928.58,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 2257.55,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3857.79,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 425.58,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5052.86,
			"r": "5",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 262.5,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 2479.77,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 14.97,
			"r": "125",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 434.39,
			"r": "47",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 218.44,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 24.92,
			"r": "116",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 39.25,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 40.2,
			"r": "102",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 7.69,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5966.15,
			"r": "3",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 19.16,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 20.55,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 300.99,
			"r": "54",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 84.69,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 54.36,
			"r": "96",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 26.59,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 90.9,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 29.06,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2566.75,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 756.62,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1423.14,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ138": {
		"UNK": null,
		"NOR": {
			"v": 4.26,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.09,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.69,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.07,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.43,
			"r": "115",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.95,
			"r": "10",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.69,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 3.78,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.24,
			"r": "120",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.36,
			"r": "37",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.44,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.68,
			"r": "20",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.56,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.47,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.58,
			"r": "24",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5,
			"r": "8",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.71,
			"r": "104",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.33,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.92,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.39,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.4,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.25,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.75,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.02,
			"r": "73",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.58,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.35,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.09,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.42,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.68,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.12,
			"r": "126",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.79,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.04,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.22,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.75,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.45,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.49,
			"r": "27",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.97,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 3.91,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.16,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.79,
			"r": "16",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "88",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.71,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.72,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.31,
			"r": "126",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.5,
			"r": "112",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.18,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.94,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.24,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.07,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 3.5,
			"r": "116",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.14,
			"r": "61",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.18,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.71,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.9,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.12,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.7,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.47,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.71,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.66,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.87,
			"r": "58",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.01,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.34,
			"r": "142",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.08,
			"r": "67",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.83,
			"r": "135",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.42,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.03,
			"r": "130",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.62,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.01,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.7,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.43,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.33,
			"r": "43",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.9,
			"r": "133",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.77,
			"r": "17",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.07,
			"r": "68",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.34,
			"r": "42",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.23,
			"r": "121",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.69,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.14,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.14,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.61,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 4.16,
			"r": "64",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.11,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.82,
			"r": "84",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.26,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.89,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.55,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.98,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.15,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.08,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.51,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 4.76,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.93,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.58,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.18,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.1,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.08,
			"r": "129",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.08,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.65,
			"r": "1",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 4.2,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 2.99,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.44,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.16,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.48,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.59,
			"r": "108",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.92,
			"r": "77",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.95,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.89,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.76,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.16,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.62,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.07,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.94,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.71,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.7,
			"r": "15",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.16,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.43,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.76,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.5,
			"r": "26",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.78,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 3.59,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.35,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.19,
			"r": "53",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.82,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.45,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.36,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.09,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.9,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 3.71,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.47,
			"r": "29",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.33,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.47,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.34,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.51,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.95,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.43,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.42,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.37,
			"r": "118",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.95,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.29,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.66,
			"r": "104",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.7,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.25,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.87,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.55,
			"r": "111",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.74,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.03,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 3.73,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.26,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.48,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.14,
			"r": "125",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-CUSTTRANSPIND": {
		"UNK": null,
		"NOR": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 1.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ057": {
		"UNK": null,
		"NOR": {
			"v": 4.07,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.51,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.84,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.1,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.87,
			"r": "117",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.14,
			"r": "25",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.15,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.05,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.59,
			"r": "14",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.44,
			"r": "50",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.81,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.21,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.19,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.38,
			"r": "92",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.46,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.78,
			"r": "81",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.19,
			"r": "29",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.43,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.57,
			"r": "84",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.73,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.94,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.38,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.07,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.19,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.2,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.33,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.94,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.87,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.6,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.7,
			"r": "41",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.01,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.24,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.52,
			"r": "129",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.08,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.26,
			"r": "138",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.62,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.91,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.67,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.85,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.48,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.12,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.17,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.07,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.95,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.04,
			"r": "103",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.04,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.37,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.83,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.21,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.49,
			"r": "131",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.11,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.02,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.96,
			"r": "111",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.33,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.72,
			"r": "125",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.99,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.42,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.19,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.95,
			"r": "70",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.36,
			"r": "54",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.1,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.92,
			"r": "54",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.51,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.95,
			"r": "68",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.88,
			"r": "35",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "121",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.05,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.76,
			"r": "40",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.36,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.06,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "59",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.7,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.52,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.81,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.15,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.13,
			"r": "27",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.02,
			"r": "108",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.13,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.46,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.86,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.71,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.84,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.94,
			"r": "140",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.69,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.11,
			"r": "105",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.16,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.14,
			"r": "137",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.03,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.47,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.93,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.1,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.62,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "135",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.96,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.97,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.29,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.92,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.24,
			"r": "96",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.3,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.35,
			"r": "56",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.23,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.51,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.41,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.55,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.14,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.92,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.99,
			"r": "8",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.14,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.67,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.77,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.24,
			"r": "136",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.87,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.83,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.55,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.28,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.46,
			"r": "132",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.43,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.5,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.91,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.53,
			"r": "86",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.77,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.67,
			"r": "45",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.77,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.61,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.04,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.12,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.01,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.55,
			"r": "16",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.41,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.91,
			"r": "114",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.8,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.77,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.42,
			"r": "91",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.57,
			"r": "15",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.15,
			"r": "23",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.79,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.5,
			"r": "1",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.88,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.33,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.19,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.4,
			"r": "53",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.03,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.5,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.01,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 1.92,
			"r": "144",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.44,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.03,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.25,
			"r": "22",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.53,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.7,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.45,
			"r": "49",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETID07": {
		"UNK": null,
		"NOR": {
			"v": 5.63,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.89,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.76,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.22,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.15,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.86,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.99,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.57,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.63,
			"r": "44",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.75,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.9,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.1,
			"r": "26",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "50",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.53,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.07,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.61,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.63,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.99,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.87,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.97,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.92,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.06,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.38,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.29,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.98,
			"r": "29",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.56,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.52,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.87,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.8,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.07,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.06,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.23,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.77,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.74,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.24,
			"r": "71",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "130",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.08,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.89,
			"r": "102",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.77,
			"r": "5",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.62,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.76,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.31,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.47,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.99,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.74,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.34,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.82,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.54,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.24,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.46,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.09,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.4,
			"r": "57",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.77,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.3,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.49,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.33,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.88,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.24,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.9,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.33,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.35,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.23,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.41,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.5,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.65,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.32,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.82,
			"r": "111",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.01,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.38,
			"r": "59",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.62,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.95,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.14,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.39,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.5,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.39,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.43,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.83,
			"r": "108",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.23,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.84,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.38,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.23,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.99,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.04,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.24,
			"r": "70",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.28,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.65,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.22,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.23,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.31,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.17,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.27,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.81,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.9,
			"r": "101",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.49,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.14,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.2,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.8,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "67",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.76,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.58,
			"r": "9",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.41,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.29,
			"r": "68",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.21,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.83,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.93,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.14,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.59,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.03,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TABCOSTEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 375,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 150,
			"r": "96",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 211.11,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 175,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 140,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 11.1,
			"r": "20",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 300,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 90,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 231,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 25,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 105,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 45,
			"r": "36",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 150,
			"r": "96",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 220,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 46.67,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 45,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 72.5,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 100,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 52.5,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 190.5,
			"r": "108",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 90,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 60,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 50,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 28,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 90,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 35,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 125,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 240,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 250,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 70,
			"r": "57",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 85,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 101.88,
			"r": "81",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 627.5,
			"r": "134",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 66.67,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 143.33,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 341.76,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 28,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 100,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 51.67,
			"r": "45",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 307.14,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 96.86,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 145,
			"r": "95",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 50,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 75,
			"r": "59",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 226.39,
			"r": "116",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 16.4,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 80,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 110,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 78,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 40,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 15,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 250,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 292,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 60,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 200,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 330,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 264,
			"r": "122",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 106.92,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 115,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 136.11,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 60,
			"r": "49",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 25,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 320,
			"r": "128",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 179.23,
			"r": "105",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 43.89,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 138.8,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 80,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 128,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 57.58,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 25,
			"r": "23",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 56.8,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2500,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 170,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 139.23,
			"r": "92",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 187.5,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 48,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 75,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 40,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 182.78,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 374.44,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 30,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "19",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 33.33,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 107.14,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 76,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 140,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 225,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 150,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 128.12,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 344,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 100,
			"r": "78",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 120,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 105,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 35,
			"r": "29",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 200,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 92,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 86,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 91.88,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 200,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 35,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 155,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 92,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 84.57,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 60,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 87,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 60.41,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 45,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 292,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 37,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 80,
			"r": "61",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 90,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 40,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 235,
			"r": "119",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 347.5,
			"r": "131",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 227.14,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 177.78,
			"r": "104",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 91.5,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 140,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 170,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 191,
			"r": "109",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 96,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 305.5,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 63.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 100,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 275,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 116.82,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 155.56,
			"r": "100",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 67,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 84,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 109,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TIMESHIP": {
		"UNK": null,
		"NOR": {
			"v": 3.77,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.39,
			"r": "67",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.71,
			"r": "115",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.94,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 3.45,
			"r": "63",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.58,
			"r": "51",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.37,
			"r": "128",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 3.23,
			"r": "75",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 4.25,
			"r": "13",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 4.03,
			"r": "23",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "125",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.64,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 3.47,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.61,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.98,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.65,
			"r": "47",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.6,
			"r": "124",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.04,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.68,
			"r": "121",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.13,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 4.27,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 3.3,
			"r": "73",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.35,
			"r": "70",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.7,
			"r": "46",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.35,
			"r": "129",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.38,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 3.29,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 4.14,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.22,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.19,
			"r": "82",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.71,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.62,
			"r": "49",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.78,
			"r": "111",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.59,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 3.04,
			"r": "92",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.95,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.14,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.93,
			"r": "100",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.7,
			"r": "45",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.73,
			"r": "113",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.69,
			"r": "119",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.81,
			"r": "107",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.99,
			"r": "95",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.63,
			"r": "48",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.31,
			"r": "72",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "58",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.56,
			"r": "52",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.72,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.83,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 4.24,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.39,
			"r": "66",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.34,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.98,
			"r": "97",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.35,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.47,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 3.12,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 3.06,
			"r": "90",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.79,
			"r": "110",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.83,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.74,
			"r": "41",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.43,
			"r": "4",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.52,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.04,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 4.04,
			"r": "21",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.2,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.88,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.71,
			"r": "116",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 4,
			"r": "26",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.7,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 3.47,
			"r": "61",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.33,
			"r": "8",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.06,
			"r": "89",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.72,
			"r": "43",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.16,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.46,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.92,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.91,
			"r": "103",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.38,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 3.12,
			"r": "87",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.79,
			"r": "109",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.29,
			"r": "9",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.94,
			"r": "98",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 4.02,
			"r": "24",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.5,
			"r": "56",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.79,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.81,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.25,
			"r": "132",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 2.02,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.94,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.8,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.45,
			"r": "3",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.46,
			"r": "127",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.08,
			"r": "88",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.85,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 3.05,
			"r": "91",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 2.93,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.5,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 3.04,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 4.03,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.41,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.9,
			"r": "104",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.37,
			"r": "7",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.83,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.88,
			"r": "105",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.61,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.86,
			"r": "106",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.93,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.53,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.8,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.74,
			"r": "112",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2.14,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 3.13,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.74,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 3,
			"r": "94",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 3.23,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 3.21,
			"r": "80",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 3.15,
			"r": "85",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 4.08,
			"r": "20",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.9,
			"r": "31",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.25,
			"r": "11",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.75,
			"r": "40",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.21,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3.23,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.45,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 3.51,
			"r": "54",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.4,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.69,
			"r": "118",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 3.23,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.88,
			"r": "32",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.68,
			"r": "120",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.8,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.19,
			"r": "83",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.23,
			"r": "133",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 4.13,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.94,
			"r": "99",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.85,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.13,
			"r": "135",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.51,
			"r": "55",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.61,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.29,
			"r": "131",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 3.4,
			"r": "65",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 3.44,
			"r": "64",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.35,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.01,
			"r": "25",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 4.12,
			"r": "19",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 4.25,
			"r": "12",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ365": {
		"UNK": null,
		"NOR": {
			"v": 6.11,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.51,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.6,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.4,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.09,
			"r": "137",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.25,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.57,
			"r": "131",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.53,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.5,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.22,
			"r": "39",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.94,
			"r": "47",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.82,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.71,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.42,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.93,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.62,
			"r": "22",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.48,
			"r": "83",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.47,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.05,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.95,
			"r": "116",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.52,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.83,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.55,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.7,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 5.26,
			"r": "35",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.33,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.9,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.23,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.29,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.62,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.43,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.09,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.74,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.45,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.05,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.58,
			"r": "75",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.46,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.87,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.62,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.51,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.73,
			"r": "126",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.95,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.61,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.7,
			"r": "65",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.91,
			"r": "51",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.71,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.11,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.53,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 3.67,
			"r": "132",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.09,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.75,
			"r": "62",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.03,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.03,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.89,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.12,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.16,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.73,
			"r": "130",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.79,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.38,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.25,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.73,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.84,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.96,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.53,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.36,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.9,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.31,
			"r": "98",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.35,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5,
			"r": "46",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.95,
			"r": "118",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.92,
			"r": "119",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.04,
			"r": "3",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.4,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.53,
			"r": "79",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.09,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.82,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.84,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.73,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.51,
			"r": "134",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.85,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "125",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.68,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.49,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.49,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.84,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.43,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.31,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.05,
			"r": "138",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.35,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.68,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.69,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.03,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.92,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.56,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.34,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.01,
			"r": "113",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 4.07,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.4,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.91,
			"r": "118",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.66,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.02,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.88,
			"r": "121",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.81,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.77,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.79,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.76,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.22,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.34,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.23,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.03,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.2,
			"r": "106",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.47,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.04,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.35,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.43,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.83,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.84,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.91,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.94,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.53,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.83,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.2,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.89,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.35,
			"r": "97",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.63,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.83,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.24,
			"r": "102",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.86,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.93,
			"r": "48",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.53,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.94,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.12,
			"r": "106",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.25,
			"r": "138",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 4.09,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.64,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.62,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.37,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.92,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.11,
			"r": "141",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.27,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.47,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.62,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.57,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.58,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.68,
			"r": "69",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ395": {
		"UNK": null,
		"NOR": {
			"v": 5.48,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.09,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.08,
			"r": "124",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.74,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.83,
			"r": "77",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.32,
			"r": "50",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.77,
			"r": "83",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.02,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.77,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.84,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.68,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "25",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.9,
			"r": "76",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.03,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.54,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.77,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.52,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.6,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.79,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.46,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.76,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.67,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.32,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.5,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.12,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.79,
			"r": "81",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.97,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.43,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.79,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.6,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.99,
			"r": "128",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.06,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.96,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.6,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.15,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.28,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.37,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.04,
			"r": "63",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.7,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.85,
			"r": "138",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.49,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.37,
			"r": "137",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.19,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.82,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.03,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.65,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.78,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.74,
			"r": "86",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.2,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.22,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.71,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.14,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.42,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.92,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.92,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.97,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.86,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "51",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.36,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.49,
			"r": "43",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.5,
			"r": "136",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.46,
			"r": "13",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.96,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.98,
			"r": "70",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.68,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.04,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.77,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.31,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.22,
			"r": "114",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.99,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.17,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.76,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.56,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.47,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.83,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.63,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.51,
			"r": "138",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.89,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.33,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.77,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.09,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.04,
			"r": "126",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "106",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.21,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.41,
			"r": "109",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.07,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.52,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.49,
			"r": "100",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.48,
			"r": "10",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.98,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.6,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.12,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.39,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.12,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.4,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.93,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.59,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.7,
			"r": "90",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.42,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.91,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.44,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.43,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.46,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.36,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.87,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.17,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.48,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.08,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.12,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.78,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.34,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.79,
			"r": "80",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.39,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.02,
			"r": "67",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.26,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.53,
			"r": "6",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.19,
			"r": "119",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.97,
			"r": "129",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.35,
			"r": "109",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.95,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.79,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.94,
			"r": "136",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.32,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.04,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.77,
			"r": "35",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.5,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.18,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.59,
			"r": "96",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 125,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1500,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 443.57,
			"r": "85",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 397,
			"r": "80",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 668.18,
			"r": "114",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 250,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 314.64,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 423,
			"r": "84",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 906,
			"r": "124",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 375,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 230,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 405,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 321.16,
			"r": "66",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "31",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 353.67,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 399.78,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 150,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 306.67,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 240,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 579.5,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 832.5,
			"r": "123",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 150,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 450,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 128.33,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 395,
			"r": "78",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 290,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 588,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 935,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 1076.79,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 190,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 489.19,
			"r": "90",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 660,
			"r": "112",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 305.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 660.38,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 143.46,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 688,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 553.67,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 957.14,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 232.55,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 511.5,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 637,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 200.56,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 969.57,
			"r": "126",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 180.71,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 420,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 282.14,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 265,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 658,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 579.17,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 635,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 278,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 490,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 1320,
			"r": "131",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 223.33,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 525,
			"r": "94",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 228.11,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 341,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 455.71,
			"r": "87",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 110.11,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 1200,
			"r": "129",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 98.08,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 82.78,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 382.59,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 482.76,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 909,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 299.67,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 315,
			"r": "65",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 265.62,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3039,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 656.67,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 392.08,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 335,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 669,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 583,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 253,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 325.62,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 465.87,
			"r": "88",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 77.3,
			"r": "28",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 297.5,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 353.57,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 134,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 1293.75,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 754.44,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 372.12,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 750,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 695,
			"r": "117",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 500,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 778.85,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 396.43,
			"r": "79",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 380,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 582,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 265,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 574.04,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 596.15,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 52,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 552.86,
			"r": "96",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 1125,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 776.61,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 175,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 655.27,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 299.21,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 582.67,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 100,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 220,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 599.11,
			"r": "106",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 545,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 655,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 152.5,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 145,
			"r": "38",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 781.71,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 677.78,
			"r": "116",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 108.5,
			"r": "33",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 457,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 561.67,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 645.57,
			"r": "108",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 701.67,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 1406.88,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 209.78,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 410,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 1350,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 595,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 171.88,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 366.5,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 389.23,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 1585,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"IMPCOSTCOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"MOBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 113.58,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 103.77,
			"r": "92",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 92.97,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 129.21,
			"r": "47",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 46.22,
			"r": "132",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 185.26,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 42.76,
			"r": "134",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 79.43,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 102.61,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 118.46,
			"r": "63",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 111.28,
			"r": "79",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 111.51,
			"r": "77",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 160.21,
			"r": "12",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 129.3,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 111.48,
			"r": "78",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 143.91,
			"r": "27",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 115.15,
			"r": "70",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 74.24,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 116.11,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 105.38,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 133.47,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 133,
			"r": "35",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 118.13,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 80.68,
			"r": "119",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 105.52,
			"r": "88",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 85.3,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 145.26,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 139.52,
			"r": "32",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 107.14,
			"r": "86",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 108.13,
			"r": "83",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 129.47,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 126.97,
			"r": "51",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 67.98,
			"r": "127",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 118.58,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 60.84,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 82.19,
			"r": "116",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 110.41,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 135.5,
			"r": "33",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 96.75,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 50.37,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 81.09,
			"r": "118",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 162.16,
			"r": "11",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 93.38,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 35.34,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 60.97,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 110.99,
			"r": "80",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 129.27,
			"r": "46",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 66.92,
			"r": "128",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 125.81,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 132.8,
			"r": "37",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 157,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 142.01,
			"r": "29",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 126.59,
			"r": "53",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 179.43,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 150.66,
			"r": "20",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 70.48,
			"r": "126",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 113.22,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 67.19,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 136.83,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 82.59,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 157.67,
			"r": "16",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 73.32,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 174.19,
			"r": "8",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 115.69,
			"r": "69",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 168.92,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 98.59,
			"r": "97",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 132.8,
			"r": "36",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 126.87,
			"r": "52",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 118.91,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 158.12,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 119.31,
			"r": "61",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 107.9,
			"r": "85",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 87.12,
			"r": "109",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 143.91,
			"r": "28",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 125.75,
			"r": "55",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 187.17,
			"r": "4",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 169,
			"r": "9",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 108.04,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 132.35,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 128.34,
			"r": "49",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 95.54,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 87.17,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 112.83,
			"r": "76",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 92.18,
			"r": "105",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 228.83,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 52.99,
			"r": "130",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 159.27,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 130.64,
			"r": "40",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 95.4,
			"r": "101",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 122.31,
			"r": "58",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 40.17,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 68.84,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 103.71,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 148.71,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 130.38,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 131.26,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 113.03,
			"r": "75",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 113.98,
			"r": "72",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 4151900,
			"r": "87",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 139.61,
			"r": "31",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 159.86,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 73.2,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 123.64,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 151.32,
			"r": "19",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 123.54,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 83.36,
			"r": "114",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 157.41,
			"r": "17",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 153.59,
			"r": "18",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 140.57,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 61.58,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 87.07,
			"r": "110",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 105.39,
			"r": "89",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 176.59,
			"r": "7",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 128.95,
			"r": "48",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 74.47,
			"r": "123",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 89.32,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 80.64,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 78.84,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 129.93,
			"r": "42",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 120.52,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 129.74,
			"r": "43",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 159.95,
			"r": "13",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 148.69,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 93.16,
			"r": "103",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 117.59,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 96.02,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 125.05,
			"r": "56",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 109.87,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 116.71,
			"r": "66",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 144.02,
			"r": "26",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 146.14,
			"r": "24",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 85.64,
			"r": "111",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 115.74,
			"r": "68",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 114.01,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 53.1,
			"r": "129",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 148.51,
			"r": "23",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 102.1,
			"r": "95",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 89.53,
			"r": "107",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 187.35,
			"r": "3",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 90.15,
			"r": "106",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 75.68,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 84.79,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 231.76,
			"r": "1",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 99.95,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 71.85,
			"r": "125",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 104.96,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 117.4,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 75.86,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 46.02,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 81.93,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 121.83,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 127.3,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 116.46,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFNUMB": {
		"UNK": null,
		"NOR": {
			"v": 736,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 18,
			"r": "43",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 22,
			"r": "54",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 6,
			"r": "21",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 395,
			"r": "91",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 169,
			"r": "77",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 274,
			"r": "79",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 11,
			"r": "32",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 8,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 102,
			"r": "73",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1686,
			"r": "104",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 5,
			"r": "10",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 12,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 344,
			"r": "89",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 492,
			"r": "97",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 15,
			"r": "39",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 15,
			"r": "39",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 18,
			"r": "43",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 321,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 81,
			"r": "71",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 11,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 61,
			"r": "68",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 2,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5,
			"r": "10",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 5,
			"r": "10",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 50,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 122,
			"r": "74",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 287,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 24,
			"r": "60",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 9,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 33,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 1924,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 61,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 764,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1810,
			"r": "105",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 6710,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 19,
			"r": "52",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 16,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 14,
			"r": "38",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 18,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 7,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 37,
			"r": "64",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 57,
			"r": "67",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 1924,
			"r": "108",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 5,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 222,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 20,
			"r": "53",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 18,
			"r": "43",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9,
			"r": "30",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 18,
			"r": "43",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 1924,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 1820,
			"r": "106",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 321,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 409,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 76,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 13,
			"r": "36",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 274,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8,
			"r": "28",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 321,
			"r": "84",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 42,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 5,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 4,
			"r": "4",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4,
			"r": "4",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "21",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 5,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 22,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 31,
			"r": "62",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 1924,
			"r": "108",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 22,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 308,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 384,
			"r": "90",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 24,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 22,
			"r": "54",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 467,
			"r": "96",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 147,
			"r": "75",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 716,
			"r": "98",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 7,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 16,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 4,
			"r": "4",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 1820,
			"r": "106",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 98,
			"r": "72",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1307,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 452,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 764,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3,
			"r": "3",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 151,
			"r": "76",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 7,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 5,
			"r": "10",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 13,
			"r": "36",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 405,
			"r": "92",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 6,
			"r": "21",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 321,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 6,
			"r": "21",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 22,
			"r": "54",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 798,
			"r": "102",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 420,
			"r": "94",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 22,
			"r": "54",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 5,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 18,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 329,
			"r": "88",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 11,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 299,
			"r": "82",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 7": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SHIPAFFORD": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "25",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.12,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.47,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.65,
			"r": "18",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.42,
			"r": "113",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.33,
			"r": "41",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.56,
			"r": "98",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.95,
			"r": "65",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.64,
			"r": "20",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.58,
			"r": "27",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "95",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.44,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.91,
			"r": "69",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.09,
			"r": "55",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.41,
			"r": "114",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.48,
			"r": "32",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.22,
			"r": "128",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.06,
			"r": "58",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.5,
			"r": "103",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.45,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.38,
			"r": "37",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 3.11,
			"r": "52",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.01,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.24,
			"r": "46",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.84,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3,
			"r": "61",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.82,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.49,
			"r": "31",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.06,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3,
			"r": "62",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.3,
			"r": "43",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.28,
			"r": "44",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.35,
			"r": "118",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.37,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.43,
			"r": "112",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.24,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.51,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.5,
			"r": "105",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.88,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.22,
			"r": "127",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.56,
			"r": "97",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.67,
			"r": "86",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.63,
			"r": "89",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.27,
			"r": "45",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.93,
			"r": "67",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.93,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.37,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.1,
			"r": "132",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.4,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.69,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 2.9,
			"r": "72",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.17,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.89,
			"r": "73",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.05,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.1,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.66,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.67,
			"r": "85",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.31,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.36,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.65,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.05,
			"r": "3",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.28,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.12,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.63,
			"r": "21",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.09,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.44,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.54,
			"r": "101",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.63,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.5,
			"r": "104",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.76,
			"r": "80",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.77,
			"r": "11",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.75,
			"r": "81",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.91,
			"r": "70",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.6,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.9,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.66,
			"r": "15",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.58,
			"r": "94",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.38,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.56,
			"r": "96",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.4,
			"r": "116",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.05,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.33,
			"r": "121",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.62,
			"r": "23",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.12,
			"r": "50",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.8,
			"r": "78",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.41,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.41,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.81,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.83,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.44,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.67,
			"r": "86",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.8,
			"r": "77",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.97,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.48,
			"r": "106",
			"m": 54,
			"y": "2015"
		},
		"MLI": {
			"v": 2.48,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.35,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.62,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.65,
			"r": "17",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 3.94,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.73,
			"r": "82",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.85,
			"r": "9",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.58,
			"r": "26",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.62,
			"r": "90",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.38,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.84,
			"r": "75",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.58,
			"r": "93",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.23,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.35,
			"r": "119",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.51,
			"r": "102",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.73,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.36,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.33,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.63,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.71,
			"r": "83",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.45,
			"r": "109",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.07,
			"r": "56",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.7,
			"r": "12",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.65,
			"r": "19",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.41,
			"r": "35",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.69,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.91,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 3.86,
			"r": "8",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.59,
			"r": "92",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 3.96,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.55,
			"r": "100",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.55,
			"r": "99",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.32,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.18,
			"r": "129",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.24,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.69,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.31,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.89,
			"r": "7",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.28,
			"r": "124",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.23,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.08,
			"r": "133",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.62,
			"r": "24",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.25,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 1.98,
			"r": "135",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.37,
			"r": "117",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.98,
			"r": "63",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.17,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.56,
			"r": "29",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 2.77,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.57,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 1.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 5.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 4.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 1.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 6.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 1.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TARIFSPECIAL": {
		"UNK": null,
		"NOR": {
			"v": 9.75,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.2,
			"r": "51",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.26,
			"r": "57",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 5.05,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 0.72,
			"r": "72",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.68,
			"r": "82",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 0.88,
			"r": "74",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 13.7,
			"r": "132",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.23,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 5.34,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 0.12,
			"r": "50",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 0.2,
			"r": "51",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 3.82,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 0.48,
			"r": "68",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 0.55,
			"r": "69",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 0,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 0.8,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.2,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 1.87,
			"r": "78",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 2.17,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 0.27,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 11.89,
			"r": "104",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 0.67,
			"r": "71",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 7.55,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 14.74,
			"r": "133",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 80.84,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0,
			"r": "1",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 0.2,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 0.45,
			"r": "67",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.32,
			"r": "64",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 11.89,
			"r": "104",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 1.97,
			"r": "79",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 0.29,
			"r": "63",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0,
			"r": "1",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 11.89,
			"r": "104",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 14.77,
			"r": "134",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.82,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 4.14,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 0.65,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.88,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 0,
			"r": "1",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 3.82,
			"r": "84",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0,
			"r": "1",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 0,
			"r": "1",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 0.26,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 0.38,
			"r": "66",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 11.89,
			"r": "104",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 0.26,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.77,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 6.23,
			"r": "97",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.26,
			"r": "57",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 4.53,
			"r": "92",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.37,
			"r": "81",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 6.06,
			"r": "96",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 0.01,
			"r": "47",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 14.77,
			"r": "134",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 0.34,
			"r": "65",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 9.84,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.67,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 6.85,
			"r": "99",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"r": "75",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.06,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"r": "1",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 4.53,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 0,
			"r": "1",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.82,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.26,
			"r": "57",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 7.75,
			"r": "101",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 6.59,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 0.26,
			"r": "57",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 0.2,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 3.98,
			"r": "89",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.11,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 1.85,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-EOSQ395": {
		"UNK": null,
		"NOR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 2.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 2.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 4.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 5.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 2.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETI_OPENFRXPART": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 4.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 2.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 2.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 3.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 3.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 1.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 1.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 2.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 2.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 4.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETID": {
		"UNK": null,
		"NOR": {
			"v": 5.63,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.89,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.76,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.22,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.15,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.86,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.99,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.57,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.63,
			"r": "44",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.75,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.9,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.1,
			"r": "26",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "50",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.53,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.07,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.61,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.63,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.99,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.87,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.97,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.92,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.06,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.38,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.29,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.98,
			"r": "29",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.56,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.52,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.87,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.8,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.07,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.06,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.23,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.77,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.74,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.24,
			"r": "71",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "130",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.08,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.89,
			"r": "102",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.77,
			"r": "5",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.62,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.76,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.31,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.47,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.99,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.74,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.34,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.82,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.54,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.24,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.46,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.09,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.4,
			"r": "57",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.77,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.3,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.49,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.33,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.88,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.24,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.9,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.33,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.35,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.23,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.41,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.5,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.65,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.32,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.82,
			"r": "111",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.01,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.38,
			"r": "59",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.62,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.95,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.14,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.39,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.5,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.39,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.43,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.83,
			"r": "108",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.23,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.84,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.38,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.23,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.99,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.04,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.24,
			"r": "70",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.28,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.65,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.22,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.23,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.31,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.17,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.27,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.81,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.9,
			"r": "101",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.49,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.14,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.2,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.8,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "67",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.76,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.58,
			"r": "9",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.41,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.29,
			"r": "68",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.21,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.83,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.93,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.14,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.59,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.03,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 3": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA02": {
		"UNK": null,
		"NOR": {
			"v": 3.64,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.63,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.3,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.53,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.91,
			"r": "19",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 3.3,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.57,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.04,
			"r": "82",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.3,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.43,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 2.85,
			"r": "114",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.56,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.31,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.18,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.43,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 3.35,
			"r": "107",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.5,
			"r": "40",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.71,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.68,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.5,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.81,
			"r": "93",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.9,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.52,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.81,
			"r": "24",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.24,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.26,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.04,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.21,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.46,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.13,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.25,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.14,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 5.11,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.43,
			"r": "123",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.38,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 3.92,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 6.46,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.02,
			"r": "3",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.86,
			"r": "21",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.3,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 1.77,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.87,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.36,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.23,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.57,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.84,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 3.71,
			"r": "95",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.51,
			"r": "122",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.86,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.26,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.79,
			"r": "25",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.53,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.95,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.9,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.43,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.46,
			"r": "42",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.2,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.67,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 2.21,
			"r": "127",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.45,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.03,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.64,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.1,
			"r": "112",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.45,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 3.9,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.74,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.63,
			"r": "99",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.41,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.83,
			"r": "92",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.34,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.89,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 2.89,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.41,
			"r": "48",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 2.15,
			"r": "130",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.45,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.62,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.07,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.07,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.46,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.12,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.33,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.6,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.84,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.7,
			"r": "97",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.57,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.36,
			"r": "52",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.45,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 2.69,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.17,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.55,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 5.33,
			"r": "12",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.36,
			"r": "53",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 2,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.57,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.28,
			"r": "61",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.56,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 2.33,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.56,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.97,
			"r": "18",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.04,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.69,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.27,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.13,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.76,
			"r": "94",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.16,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.27,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 2.38,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 2.57,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.91,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 2.02,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.23,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.18,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.28,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 4.02,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.09,
			"r": "78",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.32,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.05,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.49,
			"r": "10",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.55,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.14,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.97,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 2.12,
			"r": "131",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.29,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 4.4,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.08,
			"r": "132",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.36,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.27,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.53,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 5.62,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.97,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2.79,
			"r": "115",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.16,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1.97,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI_SECURITY": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 12": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-CUSTSERVIND": {
		"UNK": null,
		"NOR": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 2.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 2.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 3.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 3.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0403": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 10": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ353": {
		"UNK": null,
		"NOR": {
			"v": 5.41,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.57,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.65,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 3.36,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.33,
			"r": "123",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.09,
			"r": "30",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.54,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.73,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.28,
			"r": "23",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.21,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.31,
			"r": "59",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.71,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.79,
			"r": "39",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.25,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.69,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.44,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.37,
			"r": "122",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.43,
			"r": "22",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.51,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.84,
			"r": "116",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.8,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.49,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.85,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.92,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.19,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.71,
			"r": "120",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 4.37,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.92,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.36,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.67,
			"r": "87",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.92,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.06,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.59,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.44,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.68,
			"r": "121",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.82,
			"r": "117",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.15,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.25,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 1.33,
			"r": "136",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.5,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.5,
			"r": "93",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.02,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.93,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.15,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.34,
			"r": "115",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 4.33,
			"r": "58",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.01,
			"r": "70",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.73,
			"r": "84",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.18,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 1.48,
			"r": "135",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.56,
			"r": "131",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.38,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.91,
			"r": "114",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.51,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.21,
			"r": "102",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.18,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.08,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.62,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 4.45,
			"r": "56",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.55,
			"r": "46",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.76,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.3,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.36,
			"r": "112",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 6.3,
			"r": "6",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "101",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.01,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.86,
			"r": "36",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.82,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.2,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.96,
			"r": "34",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 5.17,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.52,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.86,
			"r": "134",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.8,
			"r": "79",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.6,
			"r": "12",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.13,
			"r": "107",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.02,
			"r": "109",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.18,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.91,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.73,
			"r": "9",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.49,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.95,
			"r": "113",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.26,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.24,
			"r": "126",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.35,
			"r": "4",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.27,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.85,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.84,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.25,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.01,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.04,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.56,
			"r": "123",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.23,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.13,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.6,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.03,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.17,
			"r": "105",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.54,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.22,
			"r": "62",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.27,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.58,
			"r": "44",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.45,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.37,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.78,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.54,
			"r": "89",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.92,
			"r": "74",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.53,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.21,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.78,
			"r": "80",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.11,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.64,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.98,
			"r": "71",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.18,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.87,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.13,
			"r": "111",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.53,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.31,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.75,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "82",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.98,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.58,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.59,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.7,
			"r": "10",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.49,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.32,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.56,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.62,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.41,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.66,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.71,
			"r": "85",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.74,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.88,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.01,
			"r": "132",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.43,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.25,
			"r": "24",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.01,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.38,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.16,
			"r": "129",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.62,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.16,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.06,
			"r": "67",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.43,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.96,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 1.3,
			"r": "137",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.15,
			"r": "138",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.35,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.46,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.4,
			"r": "19",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.33,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.34,
			"r": "20",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.91,
			"r": "35",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ468": {
		"UNK": null,
		"NOR": {
			"v": 5.74,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.56,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.81,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.98,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.72,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.13,
			"r": "25",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.58,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.07,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.53,
			"r": "51",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.26,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.34,
			"r": "63",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.87,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.24,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.38,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.78,
			"r": "99",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.38,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.87,
			"r": "94",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.18,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.86,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.13,
			"r": "74",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.68,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.46,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.44,
			"r": "137",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.09,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.54,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.66,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.38,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.01,
			"r": "87",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.35,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.48,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.52,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.47,
			"r": "118",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.73,
			"r": "101",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.49,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.56,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.09,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.03,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.75,
			"r": "100",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.53,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.47,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.54,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.49,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.47,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.72,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.15,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.47,
			"r": "119",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.95,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.89,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.59,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.15,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.26,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.66,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.03,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"SUR": null,
		"DOM": {
			"v": 4.47,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.13,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.76,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.47,
			"r": "12",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.41,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.17,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.13,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.85,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.98,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.67,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.03,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.11,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.95,
			"r": "133",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.27,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "80",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.28,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.44,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.81,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.83,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.58,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.64,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.67,
			"r": "39",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.97,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.16,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.97,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.06,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.79,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.72,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.7,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.23,
			"r": "125",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.23,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.56,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.63,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.02,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.07,
			"r": "131",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.99,
			"r": "132",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.61,
			"r": "110",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.29,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.62,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"r": "83",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.47,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.73,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.02,
			"r": "86",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.25,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.28,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.62,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.5,
			"r": "52",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.35,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.6,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.09,
			"r": "79",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.27,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.59,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.62,
			"r": "109",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.66,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.97,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.6,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.92,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.34,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.75,
			"r": "6",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.44,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.36,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.81,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.23,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.59,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.84,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.66,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.41,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.71,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.15,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.55,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.55,
			"r": "49",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.34,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.4,
			"r": "13",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.39,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.83,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.37,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.46,
			"r": "58",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.66,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.96,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.13,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.83,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.67,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.98,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.54,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.38,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.1,
			"r": "76",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 6.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/latest_by_indicator.json
// module id = 133
// module chunks = 0